export const partners: any = [
  {
    name: "25 Hour News",
    price: "$31.25 USD",
    description:
      "25 Hour News is a digital news platform delivering round-the-clock coverage of national and international events. It focuses on timely reporting across politics, business, technology, and current affairs. Known for its modern digital-first approach, the platform provides quick, accurate, and engaging news updates. 25 Hour News serves a growing audience seeking reliable information in real time.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://25hournews.com/news/exploring-power-in-the-metaverse-meet-the-most-influential-figures-in-metaverse-industry-globally-30489#google_vignette",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://25hournews.com/news/exploring-power-in-the-metaverse-meet-the-most-influential-figures-in-metaverse-industry-globally-30489#google_vignette",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://25hournews.com/news/exploring-power-in-the-metaverse-meet-the-most-influential-figures-in-metaverse-industry-globally-30489#google_vignette",
    },
  },

  {
    name: "The Assam Tribune",
    price: "$206.25 USD",
    description: "The Assam Tribune is an Indian English daily newspaper published from Guwahati and Dibrugarh, Assam. With over 700,000 copies of current circulation and a readership of over 3 million, it is the highest circulated English daily in northeastern India. The newspaper was founded way back in 1939 in Gauhati.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://assamtribune.com/article/top-10-must-have-car-accessories-for-2024-1549682",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://assamtribune.com/article/top-10-must-have-car-accessories-for-2024-1549682",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://assamtribune.com/article/top-10-must-have-car-accessories-for-2024-1549682",
    },

    logo: "/assets/25hournews.png", 
    logoKey: "25-hour-news", 
  },

  {
    name: "ABP Live",
    price: "$162.5 USD",
    description: "ABP Live is one of India’s leading digital news platforms operated by the ABP Group. It delivers real-time breaking news, live updates, videos, and in-depth analysis across politics, business, entertainment, and sports. With a strong digital presence, ABP Live reaches millions of users daily through its website and mobile platforms. The platform is widely trusted for its speed, accuracy, and credible journalism.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://news.abplive.com/brand-wire/national-media-club-chairman-ramesh-awasthi-launches-the-2024-edition-of-the-uttar-pradesh-media-directory-in-lucknow-1668711#:~:text=Lucknow%20(Uttar%20Pradesh)%20%5BIndia,to%20be%20published%20in%20India.",
      daChecker: "#",
      trafficChecker: "#",
    },
  },

  {
    name: "ABP Live Corporate",
    price: "$812.5 USD",
    description: "ABP News Network is a prominent Indian media organization with a strong footprint across television and digital media. The network operates multiple regional news channels and digital platforms in different languages. Known for its reliable reporting and wide reach, ABP News Network plays a significant role in shaping public opinion. It continues to be a trusted source of news across India.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://news.abplive.com/brand-wire/hero-fincorp-india-s-quickest-multipurpose-loans-provider-1673515",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://news.abplive.com/brand-wire/hero-fincorp-india-s-quickest-multipurpose-loans-provider-1673515",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://news.abplive.com/brand-wire/hero-fincorp-india-s-quickest-multipurpose-loans-provider-1673515",
    },
  },

  {
    name: "AdGully",
    price: "$162.5 USD",
    description: "Adgully is a leading digital media platform covering advertising, marketing, media, branding, and public relations. It provides industry news, expert opinions, campaign analyses, and exclusive interviews. Widely followed by marketing professionals and agencies, Adgully serves as a trusted source for insights into India’s evolving media and advertising landscape.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.adgully.com/5-signs-you-need-to-change-your-diet-141026.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.adgully.com/5-signs-you-need-to-change-your-diet-141026.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.adgully.com/5-signs-you-need-to-change-your-diet-141026.html",
    },
  },


  {
    name: "Ahmedabad Mirror w/o Backlink",
    price: "$43.75 USD",
    description: "Ahmedabad Mirror is a city-focused English daily newspaper catering to urban readers in Ahmedabad. It covers local news, civic issues, lifestyle, entertainment, and culture. Known for its crisp reporting and reader-friendly approach, the publication strongly reflects the pulse of the city.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ahmedabadmirror.com/from-mumbai-to-manhattan-a-gift-rooted-in-friendshipjay-patel-plants-a-tree-in-central-park-for-randeep-hoodas-birthday/81874300.html#goog_rewarded",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.ahmedabadmirror.com/from-mumbai-to-manhattan-a-gift-rooted-in-friendshipjay-patel-plants-a-tree-in-central-park-for-randeep-hoodas-birthday/81874300.html#goog_rewarded",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.ahmedabadmirror.com/from-mumbai-to-manhattan-a-gift-rooted-in-friendshipjay-patel-plants-a-tree-in-central-park-for-randeep-hoodas-birthday/81874300.html#goog_rewarded",
    },

    brand2:{
    name: "Ahmedabad Mirror with backlink",
    price: "$87.5 USD",
    description: "Ahmedabad Mirror is a city-focused English daily newspaper catering to urban readers in Ahmedabad. It covers local news, civic issues, lifestyle, entertainment, and culture. Known for its crisp reporting and reader-friendly approach, the publication strongly reflects the pulse of the city.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ahmedabadmirror.com/over-50-crore-abha-ids-generated-under-ayushman-bharat-digital-mission/81874385.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.ahmedabadmirror.com/over-50-crore-abha-ids-generated-under-ayushman-bharat-digital-mission/81874385.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.ahmedabadmirror.com/over-50-crore-abha-ids-generated-under-ayushman-bharat-digital-mission/81874385.html",
    },
  },
  },


  {
    name: "Analytics Insight",
    price: "$225 USD",
    description: "Analytics Insight is a global publication focused on data science, artificial intelligence, analytics, and emerging technologies. It delivers in-depth articles, expert insights, and industry reports for technology professionals and business leaders. The platform highlights innovation, digital transformation, and future-ready solutions across industries.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.allnewsbuzz.com/missed-bitcoin-these-3-cryptos-with-even-bigger-potential/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.allnewsbuzz.com/missed-bitcoin-these-3-cryptos-with-even-bigger-potential/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.allnewsbuzz.com/missed-bitcoin-these-3-cryptos-with-even-bigger-potential/",
    },


     brand2:{
    name: "Analytics Insight Do Follow",
    price: "$250 USD",
    description: "Analytics Insight is a global publication focused on data science, artificial intelligence, analytics, and emerging technologies. It delivers in-depth articles, expert insights, and industry reports for technology professionals and business leaders. The platform highlights innovation, digital transformation, and future-ready solutions across industries.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.analyticsinsight.net/innovation-and-impact-mike-bahuns-vision-for-fundraising-university/ **",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.analyticsinsight.net/innovation-and-impact-mike-bahuns-vision-for-fundraising-university/%20**",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.analyticsinsight.net/innovation-and-impact-mike-bahuns-vision-for-fundraising-university/%20**",
    }
  }

  },
  
 
  {
    name: "IBTimes SG",
    price: "$156.25 USD",
    description: "International Business Times is a globally recognized digital news publication covering business, finance, economics, and world affairs. It delivers timely reporting, market insights, and in-depth analysis for an international readership. The platform is known for its data-driven approach and comprehensive global coverage.",
    stats: {
      wordsAllowed: "Upto 700",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ibtimes.sg/scaling-through-acquisitions-chris-martins-strategies-business-growth-73790",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.ibtimes.sg/scaling-through-acquisitions-chris-martins-strategies-business-growth-73790",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.ibtimes.sg/scaling-through-acquisitions-chris-martins-strategies-business-growth-73790",
    },
  },


  
  {
    name: "Ibtimes India",
    price: "$168.75 USD",
    description: "IBT is the digital media brand associated with International Business Times, offering concise news and analysis across business, politics, technology, and global affairs. It reaches a wide international audience through fast, factual, and accessible reporting. IBT is trusted for its clarity, credibility, and global perspective.",
    stats: {  
      wordsAllowed: "Upto 700",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ibtimes.co.in/celebrating-womens-empowerment-insights-premanand-ji-maharaj-866600",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.ibtimes.co.in/celebrating-womens-empowerment-insights-premanand-ji-maharaj-866600",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.ibtimes.co.in/celebrating-womens-empowerment-insights-premanand-ji-maharaj-866600",
    },
  },
 


  
  {
    name: "APN News",
    price: "$60 USD",
    description: "APN News is a digital news platform delivering timely coverage of politics, business, current affairs, and social issues. The platform focuses on factual reporting and impactful storytelling for a growing online audience. APN News is recognized for its wide digital reach and consistent news updates across India.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.apnnews.com/artistry-in-play-blue-birds-pioneering-venture-in-the-world-of-toys-and-games/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.apnnews.com/artistry-in-play-blue-birds-pioneering-venture-in-the-world-of-toys-and-games/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.apnnews.com/artistry-in-play-blue-birds-pioneering-venture-in-the-world-of-toys-and-games/",
    },

    brand2:{
    name: "APN News DoFollow",
    price: "$100 USD",
    description: "APN News is a digital news platform delivering timely coverage of politics, business, current affairs, and social issues. The platform focuses on factual reporting and impactful storytelling for a growing online audience. APN News is recognized for its wide digital reach and consistent news updates across India.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.apnnews.com/rajaram-prasad-a-man-with-a-massive-online-following/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.apnnews.com/rajaram-prasad-a-man-with-a-massive-online-following/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.apnnews.com/rajaram-prasad-a-man-with-a-massive-online-following/",
    },
  },

  },

  {
    name: "APN News Casino",
    price: "$218.75 USD",
    description: "APN is a media and communications platform specializing in corporate news, press releases, and brand stories. It helps organizations amplify their announcements across multiple industries. APN is widely used by businesses and startups to strengthen their media presence and visibility.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.apnnews.com/tiranga-lottery-invite-code-is-7428269860-tiranga-lottery-app-register-now/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.apnnews.com/tiranga-lottery-invite-code-is-7428269860-tiranga-lottery-app-register-now/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.apnnews.com/rajaram-prasad-a-man-with-a-massive-online-following/",
    },


    brand2:{
    name: "APN News Casino DoFollow",
    price: "$306.25 USD",
    description: "APN is a media and communications platform specializing in corporate news, press releases, and brand stories. It helps organizations amplify their announcements across multiple industries. APN is widely used by businesses and startups to strengthen their media presence and visibility.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.apnnews.com/unlocking-the-secrets-how-to-maximize-your-casino-bonuses/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.apnnews.com/unlocking-the-secrets-how-to-maximize-your-casino-bonuses/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.apnnews.com/unlocking-the-secrets-how-to-maximize-your-casino-bonuses/",
    },
  },
  },
  

  {
    name: "Apsters Media",
    price: "$27.5 USD",
    description: "Apsters Media is a digital media and public relations agency specializing in online brand visibility and press coverage. It helps startups, entrepreneurs, and enterprises amplify their stories across leading global media platforms.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.apstersmedia.com/7-best-cryptocurrencies-to-buy-now-for-retirement-wealth/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.apstersmedia.com/7-best-cryptocurrencies-to-buy-now-for-retirement-wealth/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.apstersmedia.com/7-best-cryptocurrencies-to-buy-now-for-retirement-wealth/",
    },
  },


  {
    name: "AsiaNet",
    price: "$102.5 USD",
    description: "Asianet News is a premier Malayalam news channel known for its pioneering role in private satellite broadcasting in India. It is highly regarded for its in-depth political reporting and extensive coverage of issues affecting the Malayali community worldwide. The network remains a dominant force in South Indian media through its bold and credible journalism.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://newsable.asianetnews.com/pr-spot/top-8-dishes-in-ahmedabad-that-hold-the-wholesomeness-of-punjabi-flavours-sbme6b",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=%0ahttps://newsable.asianetnews.com/pr-spot/top-8-dishes-in-ahmedabad-that-hold-the-wholesomeness-of-punjabi-flavours-sbme6b",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=%0ahttps://newsable.asianetnews.com/pr-spot/top-8-dishes-in-ahmedabad-that-hold-the-wholesomeness-of-punjabi-flavours-sbme6b",
    },
  },
  
  {
    name: "Auto Hindustan Times Indexed",
    price: "$437.5 USD",
    description: "Hindustan Times is a landmark English-language daily newspaper with a legacy dating back to the Indian independence movement. It provides comprehensive coverage of national politics, business, and global affairs to millions of readers. Today, it stands as one of India's most influential multi-platform media houses.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://auto.hindustantimes.com/brand-stories/shop-for-the-best-electric-scooters-with-a-bajaj-finserv-two-wheeler-loan-41707913747099.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://auto.hindustantimes.com/brand-stories/shop-for-the-best-electric-scooters-with-a-bajaj-finserv-two-wheeler-loan-41707913747099.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://auto.hindustantimes.com/brand-stories/shop-for-the-best-electric-scooters-with-a-bajaj-finserv-two-wheeler-loan-41707913747099.html",
    },
  },

    {
    name: "Afaqs",
    price: "$287.5 USD",
    description: "afaqs! is India’s leading platform for the advertising, media, and marketing fraternity. It tracks the latest brand campaigns, agency news, and industry trends, serving as an essential resource for marketing professionals. The site is a go-to hub for anyone looking to understand the dynamics of the Indian consumer market.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.afaqs.com/news/marketing-initiatives/tvh-the-visual-house-takes-off-with-a-press-refresh",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.afaqs.com/news/marketing-initiatives/tvh-the-visual-house-takes-off-with-a-press-refresh",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.afaqs.com/news/marketing-initiatives/tvh-the-visual-house-takes-off-with-a-press-refresh",
    },
  },

  
    {
    name: "Tech Hindustan Times Indexed",
    price: "$437.5 USD",
    description: "Hindustan Times is one of India’s most respected English-language newspapers with a legacy spanning over 90 years. It offers comprehensive coverage of national and international news across print and digital platforms.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://tech.hindustantimes.com/brand-stories/evaluating-hyundai-exter-price-in-india-against-the-rising-tata-tiago-71711547541290.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://tech.hindustantimes.com/brand-stories/evaluating-hyundai-exter-price-in-india-against-the-rising-tata-tiago-71711547541290.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://tech.hindustantimes.com/brand-stories/evaluating-hyundai-exter-price-in-india-against-the-rising-tata-tiago-71711547541290.html",
    },
  },

      {
    name: "Bharat Times",
    price: "$150 USD",
    description: "Bharat Times News is a Hindi-language media outlet dedicated to providing real-time updates on national and regional affairs. Its tagline, Ab Khabar Har Samay Ki, emphasizes its commitment to round-the-clock news delivery. The channel covers a wide spectrum of topics, including politics, social issues, and local community stories across India.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://bharattimes.co.in/from-dream-to-reality-investing-in-top-5-cryptocurrencies-for-billion-dollar-returns/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://bharattimes.co.in/from-dream-to-reality-investing-in-top-5-cryptocurrencies-for-billion-dollar-returns/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://bharattimes.co.in/from-dream-to-reality-investing-in-top-5-cryptocurrencies-for-billion-dollar-returns/",
    },
  },

        {
    name: "Bhaskar Live",
    price: "$68.75 USD",
    description: "Bhaskar Live is a prominent digital news platform that delivers timely information across various sectors like politics, entertainment, and sports. It is recognized for its rapid reporting style and focus on hyper-local as well as national news. The outlet leverages a strong digital presence to keep its audience engaged with live updates and trending stories.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://bhaskarlive.in/how-often-should-you-get-an-hba1c-test/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://bhaskarlive.in/how-often-should-you-get-an-hba1c-test/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://bhaskarlive.in/how-often-should-you-get-an-hba1c-test/",
    },
  },

      {
    name: "Blunt Times",
    price: "$68.75 USD",
    description: "The Blunt Times is an emerging Indian digital news portal that prides itself on delivering blunt and unfiltered perspectives on current affairs. It covers a wide array of topics, including national politics, business, and social issues, with a focus on bold storytelling. The platform aims to provide readers with direct insights that cut through typical media jargon.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://theblunttimes.in/empowering-success-an-interview-with-network-marketing-top-earner-andrew-eaton/41248/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theblunttimes.in/empowering-success-an-interview-with-network-marketing-top-earner-andrew-eaton/41248/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theblunttimes.in/empowering-success-an-interview-with-network-marketing-top-earner-andrew-eaton/41248/",
    },
  },




  {
    name: "Boldsky",
    price: "$93.75 USD",
    description: "Boldsky is a comprehensive lifestyle and wellness platform that offers expert advice on health, beauty, fashion, and relationships. It serves as a one-stop solution for daily lifestyle challenges, providing multi-language content that includes recipes, spiritual guidance, and parenting tips. The site is particularly popular for its practical home remedies and trending wellness stories.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.boldsky.com/astrology/waiting-for-your-appraisal-check-out-astrological-prediction-for-12-zodiac-signs-in-terms-of-career-155029.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.boldsky.com/astrology/waiting-for-your-appraisal-check-out-astrological-prediction-for-12-zodiac-signs-in-terms-of-career-155029.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.boldsky.com/astrology/waiting-for-your-appraisal-check-out-astrological-prediction-for-12-zodiac-signs-in-terms-of-career-155029.html",
    },

    brand2:{
    name: "Boldsky (with backlink)",
    price: "$150 USD",
    description: "Boldsky is a comprehensive lifestyle and wellness platform that offers expert advice on health, beauty, fashion, and relationships. It serves as a one-stop solution for daily lifestyle challenges, providing multi-language content that includes recipes, spiritual guidance, and parenting tips. The site is particularly popular for its practical home remedies and trending wellness stories.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.boldsky.com/health/heres-how-often-you-should-replace-your-mattress-for-the-best-quality-sleep-152851.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.boldsky.com/health/heres-how-often-you-should-replace-your-mattress-for-the-best-quality-sleep-152851.html",
      trafficChecker: "Check Traffic",
    },
  },
  },

    {
    name: "Celeb Taxi ",
    price: "$80 USD",
    description: "Celeb Taxi is a dedicated entertainment and media outlet that focuses on the glamorous world of celebrities and showbiz. It provides real-time updates on movie releases, celebrity gossip, and exclusive red-carpet coverage. The platform is designed for fans who want a behind-the-scenes look at the lives of their favorite stars across the film and music industries.",
    stats: {  
      wordsAllowed: " ",
      backlinksAllowed: " ",
      sponsoredDisclaimer: " ",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
  },

    {
    name: "Bollywood Life ",
    price: "$153.75 USD",
    description: "Bollywood Life is a major digital entertainment hub offering real-time updates on the Hindi film industry and celebrity news. It is known for its exclusive star interviews, movie reviews, and viral stories tailored for cinema enthusiasts.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.bollywoodlife.com/brand-solution/discover-ambanis-net-worth-an-in-depth-calculation-by-zintego-2944826/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.bollywoodlife.com/brand-solution/discover-ambanis-net-worth-an-in-depth-calculation-by-zintego-2944826/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.bollywoodlife.com/brand-solution/discover-ambanis-net-worth-an-in-depth-calculation-by-zintego-2944826/",
    },
  },

    {
    name: "Bollywood Mascot",
    price: "$27.5 USD",
    description: "Bollywood Mascot is a dedicated portal for the latest movie trailers, celebrity fashion updates, and detailed box office analysis. It keeps fans engaged with the pulse of showbiz through consistent and vibrant reporting on trending entertainment topics.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://bollywoodmascot.com/lifestyle/artiste-shree-upadhyaya-a-game-changer-from-india/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://bollywoodmascot.com/lifestyle/artiste-shree-upadhyaya-a-game-changer-from-india/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://bollywoodmascot.com/lifestyle/artiste-shree-upadhyaya-a-game-changer-from-india/",
    },
  },

  {
    name: "Breezy Scroll",
    price: "$40 USD",
    description: "Breezy Scroll is a modern media outlet that delivers global news, technology, and lifestyle trends in a concise, breezy format. It is designed for fast-paced digital readers who want accurate information presented in an easy-to-digest style.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.breezyscroll.com/health/who-requires-a-testosterone-test/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.breezyscroll.com/health/who-requires-a-testosterone-test/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.breezyscroll.com/health/who-requires-a-testosterone-test/",
    },
  },


    {
    name: "Btown Stories",
    price: "$27.5 USD",
    description: "B-Town is a lifestyle and entertainment digital platform that chronicles the vibrant culture of Indian cinema and urban living. It specializes in storytelling that highlights positive and uplifting narratives from the world of showbiz and beyond. The outlet provides a unique perspective on trending celebrity news, fashion, and cultural shifts.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.btownstories.com/bade-miyan-chote-miyan-box-office-collection-day-4-akshay-kumar-and-tiger-shroff-starrer-crosses-rs-40-crore-mark/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.btownstories.com/bade-miyan-chote-miyan-box-office-collection-day-4-akshay-kumar-and-tiger-shroff-starrer-crosses-rs-40-crore-mark/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.btownstories.com/bade-miyan-chote-miyan-box-office-collection-day-4-akshay-kumar-and-tiger-shroff-starrer-crosses-rs-40-crore-mark/",
    },
  },


  {
     name: "Business Standard",
    price: "$175 USD",
    description: "Business Standard is one of India's leading financial dailies, renowned for its authoritative coverage of the economy, stock markets, and corporate sectors. It provides in-depth analysis and high-quality data that professionals rely on for making informed business decisions. The publication is highly respected for its editorial independence and comprehensive reports on global finance.",
    stats: {
      wordsAllowed: "Upto 800",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.business-standard.com/content/specials/alphavision-management-consultant-llp-set-to-transform-indian-sme-msme-landscape-with-ipo-and-strategic-fund-raising-solution-124090301245_1.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.business-standard.com/content/specials/alphavision-management-consultant-llp-set-to-transform-indian-sme-msme-landscape-with-ipo-and-strategic-fund-raising-solution-124090301245_1.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.business-standard.com/content/specials/alphavision-management-consultant-llp-set-to-transform-indian-sme-msme-landscape-with-ipo-and-strategic-fund-raising-solution-124090301245_1.html",
    },

    brand2:{
    name: "Business Standard With Link",
    price: "$300 USD",
    description: "Business Standard is one of India's leading financial dailies, renowned for its authoritative coverage of the economy, stock markets, and corporate sectors. It provides in-depth analysis and high-quality data that professionals rely on for making informed business decisions. The publication is highly respected for its editorial independence and comprehensive reports on global finance.",
    stats: {
      wordsAllowed: "Upto 800",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.business-standard.com/content/specials/how-to-calculate-your-personal-loan-emi-explained-124072700250_1.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.business-standard.com/content/specials/how-to-calculate-your-personal-loan-emi-explained-124072700250_1.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.business-standard.com/content/specials/how-to-calculate-your-personal-loan-emi-explained-124072700250_1.html",
    },
  },
  },

      {
    name: "Business Today",
    price: "$525 USD",
    description: "Business Today is a premier business magazine and digital platform that offers deep insights into the Indian corporate world and leadership strategies. It is well-known for its investigative features, CEO interviews, and annual rankings that set industry benchmarks. The brand serves as a critical resource for entrepreneurs and investors looking to stay ahead in a competitive market.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.businesstoday.in/impact-feature/story/new-android-phones-of-2024-whats-available-and-whats-coming-soon-443674-2024-08-30",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.businesstoday.in/impact-feature/story/new-android-phones-of-2024-whats-available-and-whats-coming-soon-443674-2024-08-30",
      trafficChecker: "#",
    },
  },


  {
    name: "Business Upturn DoFollow",
    price: "$112.5 USD",
    description: "Business Upturn is a rapidly growing digital news portal that delivers a broad spectrum of news across business, entertainment, technology, and sports. It focuses on providing real-time updates and trending stories to a young, global audience. The platform is designed to be a one-stop destination for readers seeking both financial intelligence and lifestyle content in a fast-paced format.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.businessupturn.com/technology/apps/sign-a-pdf-online-from-your-phone-best-mobile-apps-for-e-signatures/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.businessupturn.com/technology/apps/sign-a-pdf-online-from-your-phone-best-mobile-apps-for-e-signatures/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.businessupturn.com/technology/apps/sign-a-pdf-online-from-your-phone-best-mobile-apps-for-e-signatures/",
    },

    brand2:{
    name: "Business Upturn Casino DoFollow",
    price: "$287.5 USD",
    description: "Business Upturn is a rapidly growing digital news portal that delivers a broad spectrum of news across business, entertainment, technology, and sports. It focuses on providing real-time updates and trending stories to a young, global audience. The platform is designed to be a one-stop destination for readers seeking both financial intelligence and lifestyle content in a fast-paced format.",
    stats: {
      wordsAllowed: "Upto 1200",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.businessupturn.com/sports/the-suns-are-a-shoo-in-for-the-playoffs-again-this-season-but-their-title-chances-remain-in-question/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.businessupturn.com/sports/the-suns-are-a-shoo-in-for-the-playoffs-again-this-season-but-their-title-chances-remain-in-question/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.businessupturn.com/sports/the-suns-are-a-shoo-in-for-the-playoffs-again-this-season-but-their-title-chances-remain-in-question/",
    },
  },
  },


    {
    name: "Business World",
    price: "$225 USD",
    description: "Business World is one of India's most respected and oldest business magazines, known for its deep analytical features on the economy and corporate trends. It provides high-impact insights for entrepreneurs and executives, covering everything from startup innovation to global policy shifts. The platform remains a critical resource for decision-makers looking to stay ahead in the competitive Indian market.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://businessworld.in/article/kucoin-introduces-lifeform-in-its-27th-spotlight-ieo-pioneering-decentralised-digital-identity-518818",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://businessworld.in/article/kucoin-introduces-lifeform-in-its-27th-spotlight-ieo-pioneering-decentralised-digital-identity-518818",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://businessworld.in/article/kucoin-introduces-lifeform-in-its-27th-spotlight-ieo-pioneering-decentralised-digital-identity-518818",
    },
  },


  {
    name: "CEO Insights",
    price: "$118.75 USD",
    description: "CEO Insights is a premier business magazine that serves as a platform for industry leaders to share their experiences, challenges, and success stories. It offers a unique insider look at various corporate sectors through exclusive interviews and profiles of top-tier executives. The publication acts as a bridge between established corporate veterans and aspiring entrepreneurs seeking mentorship through leadership narratives.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ceoinsightsindia.com/news/neville-tata-leads-star-bazaar-in-nextgen-tata-retail-nwid-18519.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=%20https://www.ceoinsightsindia.com/news/neville-tata-leads-star-bazaar-in-nextgen-tata-retail-nwid-18519.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=%20https://www.ceoinsightsindia.com/news/neville-tata-leads-star-bazaar-in-nextgen-tata-retail-nwid-18519.html",
    },
  },


  
  {
    name: "Career India",
    price: "$118.75 USD",
    description: "CareerIndia is a premier education and career portal providing extensive resources for students and job seekers across India. It offers the latest updates on competitive exams, college admissions, and results, along with a vast database of study materials. The platform also features valuable career guidance, including interview tips and professional industry insights.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.careerindia.com/tips/access-top-international-stem-schools-with-prodigy-finance-040261.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.careerindia.com/tips/access-top-international-stem-schools-with-prodigy-finance-040261.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.careerindia.com/tips/access-top-international-stem-schools-with-prodigy-finance-040261.html",

      
    },

    brand2:{
      
    name: "Career India (with backlink)",
    price: "$150 USD",
    description: "CareerIndia is a premier education and career portal providing extensive resources for students and job seekers across India. It offers the latest updates on competitive exams, college admissions, and results, along with a vast database of study materials. The platform also features valuable career guidance, including interview tips and professional industry insights.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.careerindia.com/tips/access-top-international-stem-schools-with-prodigy-finance-040261.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.careerindia.com/tips/access-top-international-stem-schools-with-prodigy-finance-040261.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.careerindia.com/tips/access-top-international-stem-schools-with-prodigy-finance-040261.html",

      
    },
  
    }
  },

  
  {
    name: "Chandigarh First",
    price: "$101.25 USD",
    description: "Chandigarh First is a local digital media platform dedicated to highlighting the culture, community initiatives, and growth of the City Beautiful. It serves as an information hub for residents, focusing on local developments, urban planning, and administrative updates. The outlet aims to foster citizen engagement by keeping the public informed about the city's evolving landscape.",
    stats: {  
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://chandigarhfirst.com/build-your-instagram-empire-where-to-buy-followers-safely-and-effectively/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://chandigarhfirst.com/build-your-instagram-empire-where-to-buy-followers-safely-and-effectively/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://chandigarhfirst.com/build-your-instagram-empire-where-to-buy-followers-safely-and-effectively/",
    },

    

 
  },

{
    name: "Chandigarh Metro",
    price: "$56.25 USD",
    description: "Chandigarh Metro is a leading online news and information portal that covers the wide spectrum of life in the Chandigarh Tricity area. It features trending local news, upcoming events, and specialized sections on technology, lifestyle, and business. Recognized as a vital resource for residents, it bridges the gap between the city’s heritage and its modern digital future.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://chandigarhmetro.com/importance-of-vitamin-d-testing-what-your-levels-say-about-your-health/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://chandigarhmetro.com/importance-of-vitamin-d-testing-what-your-levels-say-about-your-health/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://chandigarhmetro.com/importance-of-vitamin-d-testing-what-your-levels-say-about-your-health/",
    },
  },

   {
    name: "Chandigarh Times",
    price: "$113.75 USD",
    description: "Chandigarh Times is a prominent lifestyle and entertainment supplement of The Times of India, focusing specifically on the vibrant culture of the Chandigarh Tricity area. It provides daily updates on local social events, celebrity visits, and trending fashion within the city. The publication serves as a key guide for residents to stay connected with the city's nightlife, dining, and community happenings.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://chandigarhtimes.net/maximize-your-social-reach-the-best-sites-to-buy-followers-on-instagram/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://chandigarhtimes.net/maximize-your-social-reach-the-best-sites-to-buy-followers-on-instagram/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://chandigarhtimes.net/maximize-your-social-reach-the-best-sites-to-buy-followers-on-instagram/",
    },
  },

  {
    name: "Cinetalkers",
    price: "$56.25 USD",
    description: "Cine Talkers is a dedicated digital media platform that captures the latest buzz from the Indian film and television industry. It specializes in providing movie reviews, celebrity interviews, and breaking news from Bollywood and regional cinema. The outlet is a popular destination for fans seeking behind-the-scenes insights and real-time updates on their favorite stars.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.cinetalkers.com/dj-uplft-energizing-delhis-nightlife-scene-with-electrifying-beats/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.cinetalkers.com/dj-uplft-energizing-delhis-nightlife-scene-with-electrifying-beats/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.cinetalkers.com/dj-uplft-energizing-delhis-nightlife-scene-with-electrifying-beats/",
    },
  },


  {
    name: "Daily Excelsior",
    price: "$106.25 USD",
    description: "Daily Excelsior is the largest circulated English daily newspaper in the state of Jammu and Kashmir, established in 1965. It is highly respected for its authoritative reporting on regional politics, security issues, and socio-economic developments in the Northern Himalayas. The publication plays a critical role in providing credible news and a voice to the people of the region.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.dailyexcelsior.com/california-auto-transportations-how-to-choose-the-right-one-for-your-needs/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.dailyexcelsior.com/california-auto-transportations-how-to-choose-the-right-one-for-your-needs/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.dailyexcelsior.com/california-auto-transportations-how-to-choose-the-right-one-for-your-needs/",
    },
  },

  {
    name: "Deccan Chronicle + Asian Age",
    price: "$243.75 USD",
    description: "The Deccan Chronicle is a leading English-language daily newspaper in India, primarily circulated in the southern states of Andhra Pradesh, Telangana, Tamil Nadu, and Karnataka. Established in 1938, it has grown into a major media house known for its extensive coverage of politics, business, and sports.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.deccanchronicle.com/in-focus/a-guide-for-online-guest-post-services-in-the-indian-market-1829250",
      daChecker: "#",
      trafficChecker: "#",
    },
  },



  {
    name: "Deccan Herald",
    price: "$181.25 USD",
    description: "Deccan Herald is a highly respected English-language newspaper headquartered in Bengaluru, known for its objective and high-quality reporting. Since 1948, it has served as a primary news source for Karnataka, offering deep insights into national affairs and regional developments. The paper is widely praised for its editorial integrity and its popular weekly supplements.",
    stats: {
      wordsAllowed: "Upto 3000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.deccanherald.com/brandpr/leadership-in-action-insights-from-paycoms-co-ceo-president-and-chairman-chad-richison-2960521",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.deccanherald.com/brandpr/leadership-in-action-insights-from-paycoms-co-ceo-president-and-chairman-chad-richison-2960521",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.deccanherald.com/brandpr/leadership-in-action-insights-from-paycoms-co-ceo-president-and-chairman-chad-richison-2960521",
    },

    brand2:{
    name: "Deccan Herald (Health)",
    price: "$187.5 USD",
    description: "Deccan Herald is a highly respected English-language newspaper headquartered in Bengaluru, known for its objective and high-quality reporting. Since 1948, it has served as a primary news source for Karnataka, offering deep insights into national affairs and regional developments. The paper is widely praised for its editorial integrity and its popular weekly supplements.",
    stats: {
      wordsAllowed: "Upto 3000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.deccanherald.com/brandspot/sponsored-health/fitspresso-reviews-coffee-recipe-should-you-buy-this-weight-loss-supplement-expert-and-real-user-reviews-2956299",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.deccanherald.com/brandspot/sponsored-health/fitspresso-reviews-coffee-recipe-should-you-buy-this-weight-loss-supplement-expert-and-real-user-reviews-2956299",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.deccanherald.com/brandspot/sponsored-health/fitspresso-reviews-coffee-recipe-should-you-buy-this-weight-loss-supplement-expert-and-real-user-reviews-2956299",
    },
  },
  },

  
  {
    name: "Dekh News",
    price: "$150 USD",
    description: "Dekh News is a contemporary digital platform that delivers real-time updates on viral trends, entertainment, and global current affairs. It caters to a tech-savvy audience by providing news in a rapid, easy-to-read format designed for social media consumption. The site is a popular destination for readers looking for the latest movie reviews and trending internet stories.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.dekhnews.com/how-to-plan-your-insurance/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.dekhnews.com/how-to-plan-your-insurance/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.dekhnews.com/how-to-plan-your-insurance/",
    },
  },


  {
    name: "DNA India",
    price: "$200 USD",
    description: "DNA India is a leading digital-first news platform that delivers comprehensive coverage of national politics, business, and entertainment. It is highly regarded for its reader-friendly analysis and investigative reporting that caters to a massive nationwide audience.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.dnaindia.com/india/report-lucky-rajor-creates-an-indelible-mark-in-the-social-media-realm-3084643",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.dnaindia.com/india/report-lucky-rajor-creates-an-indelible-mark-in-the-social-media-realm-3084643",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.dnaindia.com/india/report-lucky-rajor-creates-an-indelible-mark-in-the-social-media-realm-3084643",
    },
  },


  {
    name: "Economic Times",
    price: "$1375 USD",
    description: "The Economic Times is India's flagship financial daily and the world’s second-most widely read English business newspaper. It provides authoritative analysis on the economy, stock markets, and corporate policy for a global audience of professionals and investors.",
    stats: {
      wordsAllowed: "Upto 1100",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://economictimes.indiatimes.com/news/india/featuring-extraordinary-personalities-and-their-inspiring-journey-as-a-leader/articleshow/105289397.cms",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://economictimes.indiatimes.com/news/india/featuring-extraordinary-personalities-and-their-inspiring-journey-as-a-leader/articleshow/105289397.cms",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://economictimes.indiatimes.com/news/india/featuring-extraordinary-personalities-and-their-inspiring-journey-as-a-leader/articleshow/105289397.cms",
    },

    brand2:{
    name: "Economic Times (Spotlight)",
    price: "$937.5 USD",
    description: "The Economic Times is India's flagship financial daily and the world’s second-most widely read English business newspaper. It provides authoritative analysis on the economy, stock markets, and corporate policy for a global audience of professionals and investors.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://economictimes.indiatimes.com/markets/cryptocurrency/crypto-news/shiba-inu-shib-millionaire-reveals-three-100x-microcaps/articleshow/107514248.cms",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=%20https://economictimes.indiatimes.com/markets/cryptocurrency/crypto-news/shiba-inu-shib-millionaire-reveals-three-100x-microcaps/articleshow/107514248.cms",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=%20https://economictimes.indiatimes.com/markets/cryptocurrency/crypto-news/shiba-inu-shib-millionaire-reveals-three-100x-microcaps/articleshow/107514248.cms",
    },
  },
  },


  {
    name: "DriveSpark",
    price: "$122.5 USD",
    description: "DriveSpark is one of India's premier automotive portals, providing real-time news, expert reviews, and price updates for cars and bikes. It serves as an essential guide for enthusiasts by offering detailed technical specifications and comparisons to aid buying decisions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.drivespark.com/four-wheelers/2024/actual-ownership-prices-of-leading-compact-suvs-in-india-044415.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.drivespark.com/four-wheelers/2024/actual-ownership-prices-of-leading-compact-suvs-in-india-044415.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.drivespark.com/four-wheelers/2024/actual-ownership-prices-of-leading-compact-suvs-in-india-044415.html",
    },

    brand2:{
    name: "DriveSpark (with backlink)",
    price: "$175 USD",
    description: "DriveSpark is one of India's premier automotive portals, providing real-time news, expert reviews, and price updates for cars and bikes. It serves as an essential guide for enthusiasts by offering detailed technical specifications and comparisons to aid buying decisions.",
    stats: {
      wordsAllowed: "Upto 1100",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.drivespark.com/four-wheelers/2024/actual-ownership-prices-of-leading-compact-suvs-in-india-044415.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.drivespark.com/four-wheelers/2024/actual-ownership-prices-of-leading-compact-suvs-in-india-044415.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.drivespark.com/four-wheelers/2024/actual-ownership-prices-of-leading-compact-suvs-in-india-044415.html",
    },
  },
  },


  {
    name: "ED Times",
    price: "$32.5 USD",
    description: "ED Times is a premier youth media channel and blog that provides smart and engaging content for Indian Gen Z and millennials. It covers diverse topics like politics, social opinions, and campus news through a witty and intelligent lens designed to change reading habits. The platform is recognized for its responsible news content and has been a partner for major Bollywood productions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://edtimes.in/how-to-get-more-followers-on-instagram/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://edtimes.in/how-to-get-more-followers-on-instagram/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://edtimes.in/how-to-get-more-followers-on-instagram/",
    },
  },


  {
    name: "English Jagran",
    price: "$243.75 USD",
    description: "English Jagran is the English-language news portal of Jagran New Media, providing real-time, credible, and unbiased news updates. It caters to digital readers with coverage of national politics, sports, business, and lifestyle developments. The platform combines the legacy of the Jagran group with a modern, multimedia-rich experience including videos and web stories.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://english.jagran.com/technology/how-to-get-more-followers-on-instagram-10152886",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://english.jagran.com/technology/how-to-get-more-followers-on-instagram-10152886",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://english.jagran.com/technology/how-to-get-more-followers-on-instagram-10152886",
    },
  },


  
  {
    name: "Entertainment Paper",
    price: "$15.625 USD",
    description: "Paper Entertainment is an award-winning production company that creates scripted series and high-quality video content for a global audience. It is known for producing critically acclaimed works like the Emmy-winning series Tehran and inspiring stories related to the Indian community. The brand focuses on new age storytelling that captures unique narratives through original web shows and documentaries.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.entertainmentpaper.com/ohl-ventures-fund-pioneers-value-creation-and-innovation-in-finance-led-by-oz-clement-knight/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.entertainmentpaper.com/ohl-ventures-fund-pioneers-value-creation-and-innovation-in-finance-led-by-oz-clement-knight/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.entertainmentpaper.com/ohl-ventures-fund-pioneers-value-creation-and-innovation-in-finance-led-by-oz-clement-knight/",
    },
  },


  {
    name: "ETV Bharat",
    price: "$243.75 USD",
    description: "ETV Bharat is a comprehensive video-first news platform that delivers news in 13 Indian languages across 24 states. It utilizes a massive network of thousands of mobile journalists to provide hyper-local, regional, and national news in real-time. The platform is a pioneer in digital news, offering a personalized experience for users through its dedicated mobile app.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.etvbharat.com/en/!advertorial/why-is-sip-the-ideal-investment-strategy-enn24031903874",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.etvbharat.com/en/!advertorial/why-is-sip-the-ideal-investment-strategy-enn24031903874",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.etvbharat.com/en/!advertorial/why-is-sip-the-ideal-investment-strategy-enn24031903874",
    },
  },

    {
    name: "Fab World Today",
    price: "$28.125 USD",
    description: "Fab World Today is a digital lifestyle and entertainment portal that focuses on the latest trends in fashion, wellness, and celebrity culture. It provides readers with lighthearted, engaging content ranging from style tips and travel guides to viral entertainment news. The platform aims to be a daily source of inspiration for modern readers looking to stay updated on the fabulous side of life.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.fabworldtoday.com/magicdecor-a-new-gen-decor-tech-brand-bringing-concepts-of-quick-decor-to-india/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.fabworldtoday.com/magicdecor-a-new-gen-decor-tech-brand-bringing-concepts-of-quick-decor-to-india/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.fabworldtoday.com/magicdecor-a-new-gen-decor-tech-brand-bringing-concepts-of-quick-decor-to-india/",
    },
  },

     {
    name: "Feature Weekly",
    price: "$28.125 USD",
    description: "The Weekly Feature is a specialized digital segment or podcast-style platform, often associated with deep-dive interviews and long-form storytelling. It focuses on highlighting unique human-interest stories, industry insights, and cultural reviews on a weekly basis. The brand is designed for audiences who prefer thoughtful, curated content over rapid-fire daily news updates.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.featureweekly.com/chef-cristian-marino-revolutionizes-culinary-leadership-with-his-latest-book-the-10-rules-of-the-chef-in-the-modern-era/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.featureweekly.com/chef-cristian-marino-revolutionizes-culinary-leadership-with-his-latest-book-the-10-rules-of-the-chef-in-the-modern-era/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.featureweekly.com/chef-cristian-marino-revolutionizes-culinary-leadership-with-his-latest-book-the-10-rules-of-the-chef-in-the-modern-era/",
    },
  },

   {
    name: "Filmibeat",
    price: "$122.5 USD",
    description: "A vibrant entertainment hub that delivers movie buzz, celebrity interviews, and cultural trends. Designed for audiences who crave engaging storytelling from the world of cinema and pop culture.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.filmibeat.com/promotions/best-digital-profile-cards-for-artists-and-actors-387255.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.filmibeat.com/promotions/best-digital-profile-cards-for-artists-and-actors-387255.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.filmibeat.com/promotions/best-digital-profile-cards-for-artists-and-actors-387255.html",
    },
    brand2:{
       name: "Filmibeat (with backlinks)",
    price: "$150 USD",
    description: "A vibrant entertainment hub that delivers movie buzz, celebrity interviews, and cultural trends. Designed for audiences who crave engaging storytelling from the world of cinema and pop culture.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.filmibeat.com/promotions/best-digital-profile-cards-for-artists-and-actors-387255.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.filmibeat.com/promotions/best-digital-profile-cards-for-artists-and-actors-387255.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.filmibeat.com/promotions/best-digital-profile-cards-for-artists-and-actors-387255.html",
    },

    }
  },


   {
    name: "First India",
    price: "$93.75 USD",
    description: "A bold news platform spotlighting politics, business, and society with sharp insights and regional depth. Built for readers who value credible reporting and meaningful narratives over fleeting headlines.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://firstindia.co.in/news/press-releases/unlock-the-quran-in-your-language-get-the-groundbreaking-qurangpt-app-now-2",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://firstindia.co.in/news/press-releases/unlock-the-quran-in-your-language-get-the-groundbreaking-qurangpt-app-now-2",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://firstindia.co.in/news/press-releases/unlock-the-quran-in-your-language-get-the-groundbreaking-qurangpt-app-now-2",
    },
  },

  {
    name: "First Post",
    price: "$831.25 USD",
    description: " A digital-first news platform known for sharp analysis, long-form features, and cultural commentary. It caters to audiences who value depth, context, and clarity over quick headlines.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.firstpost.com/business/in-the-run-for-ai-implementation-dont-sidelineyour-traditional-it-priorities-13745118.html?1709562053",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.firstpost.com/business/in-the-run-for-ai-implementation-dont-sidelineyour-traditional-it-priorities-13745118.html?1709562053",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.firstpost.com/business/in-the-run-for-ai-implementation-dont-sidelineyour-traditional-it-priorities-13745118.html?1709562053",
    },
  },

  {
    name: "Forbes India",
    price: "$1500 USD",
    description: "A premier business and leadership publication spotlighting industry trends, entrepreneurial journeys, and economic insights. It’s designed for readers who seek authoritative, in-depth perspectives on success and innovation.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.forbesindia.com/article/brand-connect/best-seo-companies-for-lawyers-or-law-firms-of-2025/94556/1",
      daChecker: "#",
      trafficChecker: "#",
    },
  },

  {
    name: "Fortune India",
    price: "$1162.5 USD",
    description: " A premier business magazine offering deep insights into leadership, innovation, and market trends. It caters to readers who value authoritative analysis and long-form storytelling on the forces shaping India’s economy.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.fortuneindia.com/ideas/anirudh-pratap-singh-leading-technical-innovation-at-payomatix/118958",
      daChecker: "#",
      trafficChecker: "#",
    },
  },

  {
    name: "Free Press Journal",
    price: "$162.5 USD",
    description: "One of India’s oldest newspapers, known for its fearless reporting and cultural commentary since 1928. It engages audiences with a blend of human-interest stories, industry perspectives, and sharp editorial voices.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.freepressjournal.in/brand-focus/urvara-fertility-centre-leading-the-way-in-fertility-care-in-lucknow",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.freepressjournal.in/brand-focus/urvara-fertility-centre-leading-the-way-in-fertility-care-in-lucknow",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.freepressjournal.in/brand-focus/urvara-fertility-centre-leading-the-way-in-fertility-care-in-lucknow",
    },
  },

  {
    name: "Finnoexpert",
    price: "$31.25 USD",
    description: "A trusted financial advisory firm offering tailored solutions in wealth management, taxation, and corporate strategy. It’s designed for clients who value expert guidance and long-term financial clarity over quick fixes.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://finnoexpert.com/examplad-media-unveils-the-crucial-role-of-digital-pr-for-fintech-startups-building-brands-in-the-digital-age",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://finnoexpert.com/examplad-media-unveils-the-crucial-role-of-digital-pr-for-fintech-startups-building-brands-in-the-digital-age",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://finnoexpert.com/examplad-media-unveils-the-crucial-role-of-digital-pr-for-fintech-startups-building-brands-in-the-digital-age",
    },
  },

  {
    name: "Gadgets 360",
    price: "$293.75 USD",
    description: "A leading technology platform delivering reviews, comparisons, and industry insights on the latest gadgets. It caters to audiences who prefer reliable, in-depth analysis to make smarter tech decisions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.gadgets360.com/internet/sponsored/gadgets-to-help-you-accomplish-your-new-year-resolutions-2718671",
      daChecker: "https://www.gadgets360.com/internet/sponsored/gadgets-to-help-you-accomplish-your-new-year-resolutions-2718671",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.gadgets360.com/internet/sponsored/gadgets-to-help-you-accomplish-your-new-year-resolutions-2718671",
    },
  },

  {
    name: "Gizbot",
    price: "$122.5 USD",
    description: "A tech-driven platform delivering gadget reviews, industry updates, and digital lifestyle insights. It’s built for audiences who want smart, engaging coverage of innovations shaping the future of technology.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.gizbot.com/partner-content/data-driven-marketing-the-revolution-of-insightful-engagement-and-business-transformation-088283.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.gizbot.com/partner-content/data-driven-marketing-the-revolution-of-insightful-engagement-and-business-transformation-088283.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.gizbot.com/partner-content/data-driven-marketing-the-revolution-of-insightful-engagement-and-business-transformation-088283.html",
    },
    brand2:{
      name: "Gizbot (with backlink)",
    price: "$150 USD",
    description: "A tech-driven platform delivering gadget reviews, industry updates, and digital lifestyle insights. It’s built for audiences who want smart, engaging coverage of innovations shaping the future of technology.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.gizbot.com/partner-content/meeting-the-evolving-needs-of-on-the-go-generation-with-taiwanese-excellence-088661.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.gizbot.com/partner-content/meeting-the-evolving-needs-of-on-the-go-generation-with-taiwanese-excellence-088661.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.gizbot.com/partner-content/meeting-the-evolving-needs-of-on-the-go-generation-with-taiwanese-excellence-088661.html",
    },
    }
  },

  {
    name: "Globe Stats",
    price: "$28.125 USD",
    description: " A data-focused publication offering analysis, market trends, and global insights across industries. It caters to readers who value clarity, depth, and context in understanding the numbers behind the news.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.globestats.com/indias-no-1-astrologer-pt-umesh-chandra-pant/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.globestats.com/indias-no-1-astrologer-pt-umesh-chandra-pant/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.globestats.com/indias-no-1-astrologer-pt-umesh-chandra-pant/",
    },
  },

  {
    name: "Goa Chronicle",
    price: "$102.5 USD",
    description: "A bold digital news platform blending investigative journalism with cultural narratives. It’s built for readers who value fearless reporting and unique perspectives on India’s social and political landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://goachronicle.com/prarambh-2024-stylework-elevates-presence-as-title-sponsor-for-re-max-indias-event/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://goachronicle.com/prarambh-2024-stylework-elevates-presence-as-title-sponsor-for-re-max-indias-event/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://goachronicle.com/prarambh-2024-stylework-elevates-presence-as-title-sponsor-for-re-max-indias-event/",
    },
  },

  {
    name: "Good Returns",
    price: "$122.5 USD",
    description: "A trusted financial information hub offering insights on investments, markets, and personal finance. It serves audiences who prefer clear, reliable guidance to make smarter money decisions.",
    stats: {
      wordsAllowed: "Up to 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.goodreturns.in/partner-content/tech-powered-savings-unveiling-the-latest-innovations-in-digital-banking-1338803.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.goodreturns.in/partner-content/tech-powered-savings-unveiling-the-latest-innovations-in-digital-banking-1338803.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.goodreturns.in/partner-content/tech-powered-savings-unveiling-the-latest-innovations-in-digital-banking-1338803.html",
    },

    brand2:{
    name: "Good Returns (with backlinks)",
    price: "$168.75 USD",
    description: "A trusted financial information hub offering insights on investments, markets, and personal finance. It serves audiences who prefer clear, reliable guidance to make smarter money decisions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.goodreturns.in/partner-content/tech-powered-savings-unveiling-the-latest-innovations-in-digital-banking-1338803.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.goodreturns.in/partner-content/tech-powered-savings-unveiling-the-latest-innovations-in-digital-banking-1338803.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.goodreturns.in/partner-content/tech-powered-savings-unveiling-the-latest-innovations-in-digital-banking-1338803.html",
    },
  },
  },

  {
    name: "Hello Entrepreneur DoFollow",
    price: "$56.25 USD",
    description: "A platform dedicated to spotlighting entrepreneurial journeys, startup innovations, and leadership insights. It’s crafted for readers who value inspiration and practical wisdom from business trailblazers.",
    stats: {
      wordsAllowed: "",
      backlinksAllowed: "",
      sponsoredDisclaimer: "",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
  },

  {
    name: "Health Shots",
    price: "$337.5 USD",
    description: "A wellness-focused digital brand offering expert advice, lifestyle tips, and relatable health stories. It connects with audiences who prefer approachable, engaging content to support their everyday well-being.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.healthshots.com/brand-posts/the-importance-of-regular-lipid-profile-testing-for-cardiovascular-wellness/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.healthshots.com/brand-posts/the-importance-of-regular-lipid-profile-testing-for-cardiovascular-wellness/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.healthshots.com/brand-posts/the-importance-of-regular-lipid-profile-testing-for-cardiovascular-wellness/",
    },
  },

  

  {
    name: "Hindu Business Line",
    price: "$381.25 USD",
    description: "A trusted source for in-depth business news, market analysis, and economic trends. It serves readers who seek authoritative, long-form coverage of India’s financial and corporate landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.thehindubusinessline.com/brandhub/mastering-your-finances-with-a-personal-loan-emi-calculator/article68028445.ece",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.healthshots.com/brand-posts/the-importance-of-regular-lipid-profile-testing-for-cardiovascular-wellness/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.healthshots.com/brand-posts/the-importance-of-regular-lipid-profile-testing-for-cardiovascular-wellness/",
    },
    brand2:{
      name: "Hindu Business Line (Facebook Sharing / 3 images in Articles & 1 Video)",
    price: "$456.25 USD",
    description: "A trusted source for in-depth business news, market analysis, and economic trends. It serves readers who seek authoritative, long-form coverage of India’s financial and corporate landscape.",
    stats: {
      wordsAllowed: "Upto 2500",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.thehindubusinessline.com/brandhub/mastering-your-finances-with-a-personal-loan-emi-calculator/article68028445.ece",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.thehindubusinessline.com/brandhub/mastering-your-finances-with-a-personal-loan-emi-calculator/article68028445.ece",
      trafficChecker: "#",
    },
    }
  },

  {
    name: "Hindustan Times (w/o Index)",
    price: "$318.75 USD",
    description: "One of India’s most respected newspapers, delivering balanced reporting, cultural insights, and long-form storytelling. It connects readers to national and global conversations with credibility and depth.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.hindustantimes.com/sponsored-post/factorystoreindiacom-empowering-entrepreneurs-resellers-wholesalers-with-minimal-investment-comprehensive-support-101725288224835.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.hindustantimes.com/sponsored-post/factorystoreindiacom-empowering-entrepreneurs-resellers-wholesalers-with-minimal-investment-comprehensive-support-101725288224835.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.hindustantimes.com/sponsored-post/factorystoreindiacom-empowering-entrepreneurs-resellers-wholesalers-with-minimal-investment-comprehensive-support-101725288224835.html",
    },
    brand2:{
      name: "Hindustan Times (with Index)",
    price: "$656.25 USD",
    description: "One of India’s most respected newspapers, delivering balanced reporting, cultural insights, and long-form storytelling. It connects readers to national and global conversations with credibility and depth.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.hindustantimes.com/sponsored-post/factorystoreindiacom-empowering-entrepreneurs-resellers-wholesalers-with-minimal-investment-comprehensive-support-101725288224835.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.hindustantimes.com/sponsored-post/factorystoreindiacom-empowering-entrepreneurs-resellers-wholesalers-with-minimal-investment-comprehensive-support-101725288224835.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.hindustantimes.com/sponsored-post/factorystoreindiacom-empowering-entrepreneurs-resellers-wholesalers-with-minimal-investment-comprehensive-support-101725288224835.html",
    },
    }
  },

  
  {
    name: "India Daily Post + Daily Hunt",
    price: "$32.5 USD",
    description: "A digital news aggregator offering personalized updates across languages and regions. It’s built for audiences who prefer accessible, diverse content tailored to their daily interests.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://indiandailypost.com/revising-e-commerce-categorization-of-drinks-and-beverages/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://indiandailypost.com/revising-e-commerce-categorization-of-drinks-and-beverages/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://indiandailypost.com/revising-e-commerce-categorization-of-drinks-and-beverages/",
    },
  },

  
  {
    name: "India Saga",
    price: "$27.5 USD",
    description: "A platform dedicated to highlighting India’s evolving social, political, and cultural narratives. It serves readers who value thoughtful perspectives and curated stories beyond the mainstream.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://theindiasaga.com/saga-corner/diljit-dosanjh-reveals-untold-stories-of-bromance-with-badshah/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theindiasaga.com/saga-corner/diljit-dosanjh-reveals-untold-stories-of-bromance-with-badshah/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theindiasaga.com/saga-corner/diljit-dosanjh-reveals-untold-stories-of-bromance-with-badshah/",
    },
  },

  {
    name: "India Today",
    price: "$400 USD",
    description: "A leading news magazine and digital platform delivering sharp political analysis, cultural narratives, and investigative features. It’s built for readers who value credibility and depth in understanding India’s evolving story.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.indiatoday.in/impact-feature/story/from-code-to-vision-ashwin-ganesh-krishnamurthys-journey-of-innovation-and-impact-2523723-2024-04-05#_ftn1",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.indiatvnews.com/brand-content/pr-release/the-essential-guide-to-msme-financing-in-india-2024-04-10-925640",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.indiatoday.in/impact-feature/story/from-code-to-vision-ashwin-ganesh-krishnamurthys-journey-of-innovation-and-impact-2523723-2024-04-05#_ftn1",
    },
  },
  
  {
    name: "India TV",
    price: "$406.25 USD",
    description: "A prominent broadcast channel offering breaking news, interviews, and human-interest stories with wide national reach. It connects audiences who prefer dynamic, engaging coverage of current affairs and social issues.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.indiatvnews.com/brand-content/pr-release/the-essential-guide-to-msme-financing-in-india-2024-04-10-925640",
      daChecker: "#",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.indiatvnews.com/brand-content/pr-release/the-essential-guide-to-msme-financing-in-india-2024-04-10-925640",
    },
  },

  {
    name: "India.com",
    price: "$196.25 USD",
    description: "A digital-first platform curating news, lifestyle, and entertainment stories for a diverse audience. It serves readers who want accessible, timely updates across multiple domains in one destination.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.india.com/brand-solution/health/transform-your-smile-with-dentaturs-dental-implants-in-turkey/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.india.com/brand-solution/health/transform-your-smile-with-dentaturs-dental-implants-in-turkey/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.india.com/brand-solution/health/transform-your-smile-with-dentaturs-dental-implants-in-turkey/",
    },
  },

  
  {
    name: "Indian Television",
    price: "$287.5 USD",
    description: "A specialized media platform offering insights into broadcasting, advertising, and digital entertainment. It serves industry professionals who value in-depth coverage of trends shaping India’s television and media landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=",
    },
  },

  
  {
    name: "Infuse News",
    price: "$18.125 USD",
    description: "A modern innovation-driven brand focused on technology, growth, and transformation. It’s designed for audiences who seek dynamic solutions and forward-looking perspectives in business and tech.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.infusenews.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.infusenews.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.infusenews.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
    },
  },

  {
    name: "Interviewer PR",
    price: "$18.125 USD",
    description: "A public relations and media platform spotlighting interviews, brand stories, and promotional campaigns. It connects with audiences who appreciate authentic voices and curated narratives in the world of PR.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://interviewerpr.com/british-voice-over-actress-talks-ai-disruption-in-voiceovers-on-ajay-tambes-latest-podcast/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://interviewerpr.com/british-voice-over-actress-talks-ai-disruption-in-voiceovers-on-ajay-tambes-latest-podcast/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://interviewerpr.com/british-voice-over-actress-talks-ai-disruption-in-voiceovers-on-ajay-tambes-latest-podcast/",
    },
  },

  {
    name: "Inventiva",
    price: "$112.5 USD",
    description: "A startup and innovation-focused platform highlighting entrepreneurial journeys, market trends, and industry insights. It’s designed for readers who value fresh ideas and curated stories from India’s business ecosystem.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.inventiva.co.in/stories/role-of-complete-blood-count-cbc-in-routine-health-screenings/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.inventiva.co.in/stories/role-of-complete-blood-count-cbc-in-routine-health-screenings/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.inventiva.co.in/stories/role-of-complete-blood-count-cbc-in-routine-health-screenings/",
    },
  },
  {
    name: "Jagran Josh",
    price: "$243.75 USD",
    description: "A trusted educational resource offering exam preparation, career guidance, and knowledge-driven content. It connects with learners who prefer reliable, structured insights to achieve academic and professional success.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.jagranjosh.com/articles/what-are-the-best-career-options-after-taking-pcm-in-12th-1704965767-1",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.jagranjosh.com/articles/what-are-the-best-career-options-after-taking-pcm-in-12th-1704965767-1",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.jagranjosh.com/articles/what-are-the-best-career-options-after-taking-pcm-in-12th-1704965767-1",
    },
  },

   {
    name: "Latestly English",
    price: "$168.75 USD",
    description: "A digital-first news and lifestyle portal delivering trending updates, entertainment, and cultural commentary. It caters to audiences who enjoy fast, engaging coverage of what’s new and noteworthy.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.latestly.com/finance/what-will-secs-game-changing-approval-of-spot-bitcoin-etfs-bring-to-the-crypto-ecosystem-5718066.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.latestly.com/finance/what-will-secs-game-changing-approval-of-spot-bitcoin-etfs-bring-to-the-crypto-ecosystem-5718066.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.latestly.com/finance/what-will-secs-game-changing-approval-of-spot-bitcoin-etfs-bring-to-the-crypto-ecosystem-5718066.html",
    },
    brand2:{
      name: "Latestly Casino",
    price: "$618.75 USD",
    description: "A digital-first news and lifestyle portal delivering trending updates, entertainment, and cultural commentary. It caters to audiences who enjoy fast, engaging coverage of what’s new and noteworthy.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "5",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.latestly.com/lifestyle/uae-online-casinos-5721265.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.latestly.com/lifestyle/uae-online-casinos-5721265.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.latestly.com/lifestyle/uae-online-casinos-5721265.html",
    },
    }
  },

  {
    name: "Livemint (w/o Index)",
    price: "$437.5 USD",
    description: " A leading financial news platform offering sharp analysis, market updates, and economic insights. It’s built for readers who value clarity and depth in understanding India’s business and financial landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.livemint.com/sponsored-post/dubais-avenix-fzco-launches-forexigo-a-new-forex-robot-for-algorithmic-trading-11722499291256.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.livemint.com/sponsored-post/dubais-avenix-fzco-launches-forexigo-a-new-forex-robot-for-algorithmic-trading-11722499291256.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.livemint.com/sponsored-post/dubais-avenix-fzco-launches-forexigo-a-new-forex-robot-for-algorithmic-trading-11722499291256.html",
    },
    brand2:{
      name: "Livemint (with index)",
    price: "$825 USD",
    description: "A leading financial news platform offering sharp analysis, market updates, and economic insights. It’s built for readers who value clarity and depth in understanding India’s business and financial landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.livemint.com/sponsored-post/dubais-avenix-fzco-launches-forexigo-a-new-forex-robot-for-algorithmic-trading-11722499291256.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.livemint.com/sponsored-post/dubais-avenix-fzco-launches-forexigo-a-new-forex-robot-for-algorithmic-trading-11722499291256.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.livemint.com/sponsored-post/dubais-avenix-fzco-launches-forexigo-a-new-forex-robot-for-algorithmic-trading-11722499291256.html",
    },
    }
  },

  {
    name: "Lokmat Times",
    price: "$112.5 USD",
    description: "A respected publication blending heritage with contemporary reporting, covering politics, culture, and society. It serves audiences who appreciate credible journalism with regional and national relevance.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.lokmattimes.com/business/whats-the-significance-of-my-pan-number-today-a475/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.lokmattimes.com/business/whats-the-significance-of-my-pan-number-today-a475/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.lokmattimes.com/business/whats-the-significance-of-my-pan-number-today-a475/",
    },
  },
  {
    name: "Marketing Mind",
    price: "$118.75 USD",
    description: "A creative hub spotlighting branding strategies, industry trends, and entrepreneurial ideas. It connects with readers who seek unique, insightful perspectives on marketing and innovation.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://marketingmind.in/ageless-vitality-and-wellness-with-civsa/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://marketingmind.in/ageless-vitality-and-wellness-with-civsa/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://marketingmind.in/ageless-vitality-and-wellness-with-civsa/",
    },
  },


   {
    name: "Midday (H)(Any Review Article and Health Affiliate Articles)",
    price: "$112.5 USD",
    description: "A metro-focused digital news platform delivering city updates, lifestyle stories, and human-interest features. It’s built for readers who prefer engaging, relatable coverage of urban life and culture.",
    stats: {
      wordsAllowed: "Upto 6000",
      backlinksAllowed: "20",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.mid-day.com/lifestyle/infotainment/article/green-acres-cbd-gummies-diabetes-green-farm-cbd-thc-gummies-is-green-acre-23344200",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.mid-day.com/lifestyle/infotainment/article/green-acres-cbd-gummies-diabetes-green-farm-cbd-thc-gummies-is-green-acre-23344200",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.mid-day.com/lifestyle/infotainment/article/green-acres-cbd-gummies-diabetes-green-farm-cbd-thc-gummies-is-green-acre-23344200",
    },
    brand2:{
      name: "Midday (N) Normal Articles (Apart from any review, crypto, health affiliate articles)",
    price: "$115 USD",
    description: "A metro-focused digital news platform delivering city updates, lifestyle stories, and human-interest features. It’s built for readers who prefer engaging, relatable coverage of urban life and culture.",
    stats: {
      wordsAllowed: "Upto 6000",
      backlinksAllowed: "5",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.mid-day.com/brand-media/business-and-services/article/team-rustic-and-eva-live-forge-a-strategic-partnership-redefining-the-ip-and-event-landscape-482",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.mid-day.com/brand-media/business-and-services/article/team-rustic-and-eva-live-forge-a-strategic-partnership-redefining-the-ip-and-event-landscape-482",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.mid-day.com/brand-media/business-and-services/article/team-rustic-and-eva-live-forge-a-strategic-partnership-redefining-the-ip-and-event-landscape-482",
    },
    },

    brand3:{
      name: "Midday DoFollow",
    price: "$287.5 USD",
    description: "A metro-focused digital news platform delivering city updates, lifestyle stories, and human-interest features. It’s built for readers who prefer engaging, relatable coverage of urban life and culture.",
    stats: {
      wordsAllowed: "Upto 10000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.mid-day.com/brand-media/business-and-services/article/jio-5g-for-business-unlimited-data-solutions-for-growing-enterprises-516",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.mid-day.com/brand-media/business-and-services/article/jio-5g-for-business-unlimited-data-solutions-for-growing-enterprises-516",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.mid-day.com/brand-media/business-and-services/article/jio-5g-for-business-unlimited-data-solutions-for-growing-enterprises-516",
    },
    }
  },
   {
      name: "Money Control",
    price: "$912.5 USD",
    description: "India’s leading financial portal offering market analysis, investment tools, and economic insights. It serves audiences who value reliable, in-depth guidance for smarter financial decisions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.moneycontrol.com/news/brand-connect/how-trendy-traders-academy-makes-profitable-traders-15000-students-countless-success-stories-12600991.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.moneycontrol.com/news/brand-connect/how-trendy-traders-academy-makes-profitable-traders-15000-students-countless-success-stories-12600991.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.moneycontrol.com/news/brand-connect/how-trendy-traders-academy-makes-profitable-traders-15000-students-countless-success-stories-12600991.html",
    }
    },
   {
      name: "My Khel",
    price: "$122.5 USD",
    description: "A sports-centric platform covering live scores, athlete stories, and game analysis. It connects with fans who enjoy dynamic, accessible coverage of sporting events and achievements.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.mykhel.com/temp/is-she-the-next-big-thing-madonna-tixeira-tv-presenter-corporate-emcee-who-boldly-leads-from-front-229789.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.mykhel.com/temp/is-she-the-next-big-thing-madonna-tixeira-tv-presenter-corporate-emcee-who-boldly-leads-from-front-229789.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.mykhel.com/temp/is-she-the-next-big-thing-madonna-tixeira-tv-presenter-corporate-emcee-who-boldly-leads-from-front-229789.html",
    },
    brand2:{
      name: "My Khel (with backlink)",
    price: "$156.25 USD",
    description: "A sports-centric platform covering live scores, athlete stories, and game analysis. It connects with fans who enjoy dynamic, accessible coverage of sporting events and achievements.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.mykhel.com/temp/is-she-the-next-big-thing-madonna-tixeira-tv-presenter-corporate-emcee-who-boldly-leads-from-front-229789.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.mykhel.com/temp/is-she-the-next-big-thing-madonna-tixeira-tv-presenter-corporate-emcee-who-boldly-leads-from-front-229789.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.mykhel.com/temp/is-she-the-next-big-thing-madonna-tixeira-tv-presenter-corporate-emcee-who-boldly-leads-from-front-229789.html",
    },

    }
    },
    {
      name: "Mynation",
    price: "$77.5 USD",
    description: "A digital news platform offering sharp perspectives on politics, society, and culture. It’s built for readers who value bold narratives and curated insights beyond conventional reporting.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.mynation.com/business/how-to-get-more-followers-on-tiktok-sb9eiq",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.mynation.com/business/how-to-get-more-followers-on-tiktok-sb9eiq",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.mynation.com/business/how-to-get-more-followers-on-tiktok-sb9eiq",
    },

    },

    {
      name: "Nagpur Oranges",
    price: "$32.5 USD",
    description: "A regional magazine blending business coverage with lifestyle and cultural stories. It caters to audiences who appreciate local flavor alongside industry-focused insights.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://nagpuroranges.com/sip-calculator-heres-how-%e2%82%b91000-monthly-investment-can-become-%e2%82%b910-lakhs/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://nagpuroranges.com/sip-calculator-heres-how-%e2%82%b91000-monthly-investment-can-become-%e2%82%b910-lakhs/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://nagpuroranges.com/sip-calculator-heres-how-%e2%82%b91000-monthly-investment-can-become-%e2%82%b910-lakhs/",
    },
    },
    {
      name: "Nagpur Today",
    price: "$52.5 USD",
    description: "A city-centric news outlet delivering timely updates, features, and community stories. It connects with readers who prefer accessible, reliable coverage of Nagpur’s evolving social and civic landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.nagpurtoday.in/personal-loans-simplified-how-to-apply-and-get-approved-in-minutes-from-your-phone/04110916",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.nagpurtoday.in/personal-loans-simplified-how-to-apply-and-get-approved-in-minutes-from-your-phone/04110916",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.nagpurtoday.in/personal-loans-simplified-how-to-apply-and-get-approved-in-minutes-from-your-phone/04110916",
    },
    brand2:{
      name: "Nagpur Today DoFollow",
    price: "$93.75 USD",
    description: "A city-centric news outlet delivering timely updates, features, and community stories. It connects with readers who prefer accessible, reliable coverage of Nagpur’s evolving social and civic landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.nagpurtoday.in/how-to-manage-your-unexpected-wedding-expenses/03111757",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.nagpurtoday.in/how-to-manage-your-unexpected-wedding-expenses/03111757",
      trafficChecker: "#",
    },
    }
    },
{
      name: "NDTV",
    price: "$243.75 USD",
    description: "A pioneering news network delivering credible journalism, investigative features, and cultural narratives. It’s built for audiences who value balanced, in-depth coverage of India’s political, social, and economic landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.ndtv.com/partner-content/shakti-ageless-and-healthy-living-conclave-celebrates-success-in-promoting-wellness-and-vitality-5382963",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.ndtv.com/partner-content/shakti-ageless-and-healthy-living-conclave-celebrates-success-in-promoting-wellness-and-vitality-5382963",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.ndtv.com/partner-content/shakti-ageless-and-healthy-living-conclave-celebrates-success-in-promoting-wellness-and-vitality-5382963",
    }
    },

    {
      name: "News 18 No Index",
    price: "$877.5 USD",
    description: "A leading Hindi news channel offering sharp reporting, regional insights, and national updates. It connects with viewers who prefer dynamic, accessible coverage of stories shaping India today.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.news18.com/studio18/apollo-tyres-endutrax-adventure-at-natrax-indore-showcasing-the-tenacity-and-performance-of-the-endutrax-portfolio-8824157.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.news18.com/studio18/apollo-tyres-endutrax-adventure-at-natrax-indore-showcasing-the-tenacity-and-performance-of-the-endutrax-portfolio-8824157.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.news18.com/studio18/apollo-tyres-endutrax-adventure-at-natrax-indore-showcasing-the-tenacity-and-performance-of-the-endutrax-portfolio-8824157.html",
    }
    },

    
    {
      name: "News Gram",
    price: "$150 USD",
    description: "A regional digital outlet spotlighting community stories, civic updates, and cultural perspectives. It serves readers who appreciate timely, localized reporting with a strong connection to Nashik’s identity.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.newsgram.com/education/2024/02/28/questions-to-consider-before-purchasing-a-child-education-plan",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.newsgram.com/education/2024/02/28/questions-to-consider-before-purchasing-a-child-education-plan",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.newsgram.com/education/2024/02/28/questions-to-consider-before-purchasing-a-child-education-plan",
    }
    },
    {
      name: "News Live TV",
    price: "$56.25 USD",
    description: "A broadcast platform delivering timely updates, interviews, and community stories. It’s built for viewers who prefer accessible, engaging coverage of current affairs and local voices.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://newslivetv.com/xbird-hits-new-highs-for-consecutive-days-hard-forked-babybird-to-be-listed-on-large-exchanges/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://newslivetv.com/xbird-hits-new-highs-for-consecutive-days-hard-forked-babybird-to-be-listed-on-large-exchanges/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://newslivetv.com/xbird-hits-new-highs-for-consecutive-days-hard-forked-babybird-to-be-listed-on-large-exchanges/",
    }
    },


{
      name: "News Nation",
    price: "$90 USD",
    description: "A national news channel offering sharp reporting, investigative features, and cultural insights. It connects with audiences who value credible, in-depth coverage of India’s evolving landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://english.newsnationtv.com/brand-stories/brand-stories-english/anaghtara-susmita-gupta-seeks-to-make-an-impact-on-indias-obsession-with-american-diamonds-and-healing-crystals-259799.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://english.newsnationtv.com/brand-stories/brand-stories-english/anaghtara-susmita-gupta-seeks-to-make-an-impact-on-indias-obsession-with-american-diamonds-and-healing-crystals-259799.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://english.newsnationtv.com/brand-stories/brand-stories-english/anaghtara-susmita-gupta-seeks-to-make-an-impact-on-indias-obsession-with-american-diamonds-and-healing-crystals-259799.html",
    }
    },
  
    
{
      name: "News Patrolling",
    price: "$31.25 USD",
    description: "A digital outlet spotlighting diverse perspectives across politics, business, lifestyle, and entertainment. It serves readers who appreciate curated, wide-ranging stories beyond mainstream headlines.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
    },
    brand2:{
      name: "News Patrolling With links",
    price: "$43.75 USD",
    description: "A digital outlet spotlighting diverse perspectives across politics, business, lifestyle, and entertainment. It serves readers who appreciate curated, wide-ranging stories beyond mainstream headlines.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
    },
    }
    },
    {
      name: "News Track Live",
    price: "$43.75 USD",
    description: "A digital news outlet blending national updates with regional perspectives and cultural stories. It’s built for readers who value diverse coverage and sharp insights across India’s evolving landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://english.newstracklive.com/news/big-rock-nutrition-best-whey-protein-in-india-for-muscle-growth-and-recovery-sc53-nu371-1315291-1.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://newspatrolling.com/ous-royal-academy-secures-approval-from-government-of-dubai-for-vocational-programs/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://english.newstracklive.com/news/big-rock-nutrition-best-whey-protein-in-india-for-muscle-growth-and-recovery-sc53-nu371-1315291-1.html",
    },
    brand2:{
      name: "News Track Live (FB/Instagram/(Twitter)X sharing)",
    price: "$93.75 USD",
    description: "A digital news outlet blending national updates with regional perspectives and cultural stories. It’s built for readers who value diverse coverage and sharp insights across India’s evolving landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://english.newstracklive.com/news/big-rock-nutrition-best-whey-protein-in-india-for-muscle-growth-and-recovery-sc53-nu371-1315291-1.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://english.newstracklive.com/news/big-rock-nutrition-best-whey-protein-in-india-for-muscle-growth-and-recovery-sc53-nu371-1315291-1.html",
      trafficChecker: "#",
    },
    }
    },

    {
      name: "Business Upturn Casino DoFollow",
    price: "$118.75 USD",
    description: "A business-focused platform delivering industry analysis, entrepreneurial stories, and market trends. It caters to audiences who prefer clear, curated insights into the forces shaping commerce and innovation.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://english.newstracklive.com/news/zelensky-aims-for-peace-summit-to-accelerate-end-to-ukraine-war-how-it-could-shape-europe-sc57-nu318-ta318-1319096-1.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://english.newstracklive.com/news/zelensky-aims-for-peace-summit-to-accelerate-end-to-ukraine-war-how-it-could-shape-europe-sc57-nu318-ta318-1319096-1.html",
      trafficChecker: "#",
    },
    },
    {
      name: "NewsD",
    price: "$81.25 USD",
    description: "A modern digital channel spotlighting current affairs, technology, and global perspectives. It connects with viewers who appreciate dynamic, accessible reporting with a contemporary edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://newsd.in/how-to-get-more-followers-on-instagram/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://newsd.in/how-to-get-more-followers-on-instagram/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://newsd.in/how-to-get-more-followers-on-instagram/",
    },
    },

    {
      name: "NewsHeads",
    price: "$56.25 USD",
    description: "A digital platform delivering concise updates, features, and commentary across politics, business, and culture. It’s built for readers who prefer clear, accessible coverage of current affairs.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.newsheads.in/india/news/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding-article-72074",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.newsheads.in/india/news/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding-article-72074",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.newsheads.in/india/news/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding-article-72074",
    },
    brand2:{
      name: "NewsHeads DoFollow",
    price: "$115 USD",
    description: "A digital platform delivering concise updates, features, and commentary across politics, business, and culture. It’s built for readers who prefer clear, accessible coverage of current affairs.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.newsheads.in/business/finance-and-markets/bumper-to-bumper-cover-explained-article-72161",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.newsheads.in/business/finance-and-markets/bumper-to-bumper-cover-explained-article-72161",
      trafficChecker: "#",
    },
    }
    },
    
    {
      name: "National Herald",
    price: "$118.75 USD",
    description: "A historic publication known for its legacy of fearless journalism and socio-political analysis. It connects with audiences who value credible reporting and thoughtful perspectives on India’s democratic journey",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.nationalheraldindia.com/advertorial/dr-parth-shah-announces-hair-transplant-services-are-now-available-at-casa-dentique-navi",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.nationalheraldindia.com/advertorial/dr-parth-shah-announces-hair-transplant-services-are-now-available-at-casa-dentique-navi",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.nationalheraldindia.com/advertorial/dr-parth-shah-announces-hair-transplant-services-are-now-available-at-casa-dentique-navi",
    },
    },

    {
      name: "North East Now",
    price: "$87.5 USD",
    description: "A regional outlet spotlighting news, culture, and civic issues from India’s Northeast. It serves readers who appreciate timely, localized coverage with a strong community focus.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://nenow.in/science-technology/how-to-get-more-followers-on-tiktok.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://nenow.in/science-technology/how-to-get-more-followers-on-tiktok.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://nenow.in/science-technology/how-to-get-more-followers-on-tiktok.html",
    },
    },

    
    {
      name: "North India Daily",
    price: "$81.25 USD",
    description: "A digital news outlet delivering breaking updates and regional perspectives with immediacy. It’s built for readers who value timely, accessible coverage of stories shaping North India.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=",
    },
    },
    {
      name: "NYK Daily",
    price: "$62.5 USD",
    description: "A global knowledge platform blending news, history, and thought leadership. It connects with audiences who prefer insightful, narrative-driven content designed to broaden perspectives and spark curiosity.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://nykdaily.com/2024/03/group-personal-accident-coverage-up-to-15-lakhs-for-accidental-death/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://nykdaily.com/2024/03/group-personal-accident-coverage-up-to-15-lakhs-for-accidental-death/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://nykdaily.com/2024/03/group-personal-accident-coverage-up-to-15-lakhs-for-accidental-death/",
    },
    },

    {
      name: "One India",
    price: "$122.5 USD",
    description: "A multilingual digital portal offering news, lifestyle, and entertainment across India. It serves readers who appreciate diverse, inclusive coverage tailored to regional and national interests.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "0",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.oneindia.com/partner-content/securing-your-online-banking-essential-steps-to-safeguard-your-financial-information-3796431.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.oneindia.com/partner-content/securing-your-online-banking-essential-steps-to-safeguard-your-financial-information-3796431.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.oneindia.com/partner-content/securing-your-online-banking-essential-steps-to-safeguard-your-financial-information-3796431.html",
    },
    brand2:{
      name: "One India (with backlinks)",
    price: "$156.25 USD",
    description: "A multilingual digital portal offering news, lifestyle, and entertainment across India. It serves readers who appreciate diverse, inclusive coverage tailored to regional and national interests.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.oneindia.com/partner-content/securing-your-online-banking-essential-steps-to-safeguard-your-financial-information-3796431.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.oneindia.com/partner-content/securing-your-online-banking-essential-steps-to-safeguard-your-financial-information-3796431.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.oneindia.com/partner-content/securing-your-online-banking-essential-steps-to-safeguard-your-financial-information-3796431.html",
    },
    }
    },
    {
      name: "Only My Health",
    price: "$231.25 USD",
    description: "A wellness platform offering expert-backed health tips, lifestyle guidance, and medical insights. It connects with audiences who prefer practical, approachable content to support everyday well-being.",
    stats: {
      wordsAllowed: "Upto 3000",
      backlinksAllowed: "5",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.onlymyhealth.com/buzz/best-three-hgh-supplements-for-women-1725375143",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.onlymyhealth.com/buzz/best-three-hgh-supplements-for-women-1725375143",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.onlymyhealth.com/buzz/best-three-hgh-supplements-for-women-1725375143",
    },
    },


    {
      name: "Open The News",
    price: "$27.5 USD",
    description: "A contemporary digital outlet delivering sharp reporting, diverse perspectives, and dynamic coverage of current affairs. It’s built for readers who value clarity, accessibility, and modern storytelling in news.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.openthenews.com/cryptocurrency-titans-10-leaders-redefining-digital-wealth-worldwide/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.openthenews.com/cryptocurrency-titans-10-leaders-redefining-digital-wealth-worldwide/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.openthenews.com/cryptocurrency-titans-10-leaders-redefining-digital-wealth-worldwide/",
    },
    },

    
    {
      name: "Orissa Post",
    price: "$116.25 USD",
    description: "A regional newspaper providing credible updates, cultural narratives, and civic reporting from Odisha. It serves readers who appreciate timely, localized coverage with national relevance.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.orissapost.com/5-ways-to-boost-immune-power/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.orissapost.com/5-ways-to-boost-immune-power/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.orissapost.com/5-ways-to-boost-immune-power/",
    },
    },

    
    {
      name: "Outlook India (hub4business - For normal articles, Business and news)",
    price: "$293.75 USD",
    description: "A flagship magazine delivering incisive commentary, investigative features, and cultural narratives. It’s built for readers who value sharp perspectives and credible journalism across politics, society, and lifestyle.",
    stats: {
      wordsAllowed: "Upto 3500",
      backlinksAllowed: "8",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.outlookindia.com/hub4business/this-homegrown-qsr-chain-challenges-kfcs-chicken-supremacy-in-india",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.outlookindia.com/hub4business/this-homegrown-qsr-chain-challenges-kfcs-chicken-supremacy-in-india",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.outlookindia.com/hub4business/this-homegrown-qsr-chain-challenges-kfcs-chicken-supremacy-in-india",
    },
    brand2:{
      
      name: "Outlook India (hub4gaming - For casino articles in English)",
    price: "$368.75 USD",
    description: "A flagship magazine delivering incisive commentary, investigative features, and cultural narratives. It’s built for readers who value sharp perspectives and credible journalism across politics, society, and lifestyle.",
    stats: {
      wordsAllowed: "Upto 3500",
      backlinksAllowed: "8",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.outlookindia.com/hub4gaming/fun-games-turn-into-real-money-earning-games",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.outlookindia.com/hub4gaming/fun-games-turn-into-real-money-earning-games",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.outlookindia.com/hub4gaming/fun-games-turn-into-real-money-earning-games",
    },
    },
    brand3:{
      
      name: "Outlook India (hub4health - Health affiliacte articles)",
    price: "$293.75 USD",
    description: "A flagship magazine delivering incisive commentary, investigative features, and cultural narratives. It’s built for readers who value sharp perspectives and credible journalism across politics, society, and lifestyle.",
    stats: {
      wordsAllowed: "Upto 3500",
      backlinksAllowed: "8",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.outlookindia.com/hub4health/java-burn-reviews-real-results-or-hype-is-java-burn-coffee-safe-for-weight-loss-discover-ingredients-benefits-pros-cons",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.outlookindia.com/hub4health/java-burn-reviews-real-results-or-hype-is-java-burn-coffee-safe-for-weight-loss-discover-ingredients-benefits-pros-cons",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.outlookindia.com/hub4health/java-burn-reviews-real-results-or-hype-is-java-burn-coffee-safe-for-weight-loss-discover-ingredients-benefits-pros-cons",
    },
    },
    brand4:{
      
      name: "Outlook India (outlookhub - Review Articles)",
    price: "$293.75 USD",
    description: "A flagship magazine delivering incisive commentary, investigative features, and cultural narratives. It’s built for readers who value sharp perspectives and credible journalism across politics, society, and lifestyle.",
    stats: {
      wordsAllowed: "Upto 3500",
      backlinksAllowed: "8",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.outlookindia.com/outlookhub/immediate-apex-review-2024-legit-trading-platform-crypto-update",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.outlookindia.com/outlookhub/immediate-apex-review-2024-legit-trading-platform-crypto-update",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.outlookindia.com/outlookhub/immediate-apex-review-2024-legit-trading-platform-crypto-update",
    },
    },
    brand5:{
      
      name: "Outlook India (plugin-play - Other Language Articles)",
    price: "$293.75 USD",
    description: "A flagship magazine delivering incisive commentary, investigative features, and cultural narratives. It’s built for readers who value sharp perspectives and credible journalism across politics, society, and lifestyle.",
    stats: {
      wordsAllowed: "Upto 3500",
      backlinksAllowed: "8",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.outlookindia.com/plugin-play/2024%EB%85%84-%EA%B5%AD%EB%82%B4-%EC%8A%AC%EB%A1%AF%EC%82%AC%EC%9D%B4%ED%8A%B8-%EC%B6%94%EC%B2%9C-%EC%88%9C%EC%9C%84-top3",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.outlookindia.com/plugin-play/2024%EB%85%84-%EA%B5%AD%EB%82%B4-%EC%8A%AC%EB%A1%AF%EC%82%AC%EC%9D%B4%ED%8A%B8-%EC%B6%94%EC%B2%9C-%EC%88%9C%EC%9C%84-top3",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.outlookindia.com/plugin-play/2024%EB%85%84-%EA%B5%AD%EB%82%B4-%EC%8A%AC%EB%A1%AF%EC%82%AC%EC%9D%B4%ED%8A%B8-%EC%B6%94%EC%B2%9C-%EC%88%9C%EC%9C%84-top3",
    },
    }
    },

    {
      name: "Outlook Money",
    price: "$243.75 USD",
    description: "A trusted financial publication offering expert insights on investments, markets, and personal finance. It connects with audiences who prefer clear, practical guidance for smarter financial decisions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "5",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.google.com/amp/s/www.outlookmoney.com/amp/outlook-money-spotlight/global-macroeconomic-challenges-ripple-through-venture-capital-funding-as-india-emerges-as-an-investment-outlier-8958",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.google.com/amp/s/www.outlookmoney.com/amp/outlook-money-spotlight/global-macroeconomic-challenges-ripple-through-venture-capital-funding-as-india-emerges-as-an-investment-outlier-8958",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.outlookindia.com/plugin-play/2024%EB%85%84-%EA%B5%AD%EB%82%B4-%EC%8A%AC%EB%A1%AF%EC%82%AC%EC%9D%B4%ED%8A%B8-%EC%B6%94%EC%B2%9C-%EC%88%9C%EC%9C%84-top3",
    },
    },

    {
      name: "Pop Diaries",
    price: "$68.75 USD",
    description: "A vibrant digital brand spotlighting entertainment, trends, and pop culture narratives. It caters to readers who enjoy lively, engaging content with a creative edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://popdiaries.com/digital/bringing-ancient-wisdom-into-the-digital-age-the-free-app-transforming-how-we-connect-with-the-quran-4105567",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://popdiaries.com/digital/bringing-ancient-wisdom-into-the-digital-age-the-free-app-transforming-how-we-connect-with-the-quran-4105567",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://popdiaries.com/digital/bringing-ancient-wisdom-into-the-digital-age-the-free-app-transforming-how-we-connect-with-the-quran-4105567",
    },
    },

    {
      name: "Postman News + Daily Hunt",
    price: "$70 USD",
    description: "A digital outlet spotlighting fresh perspectives, civic updates, and cultural stories. It’s built for readers who value timely, engaging coverage with a modern edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://postmannews.com/saregamas-talent-pragati-nagpal-unveils-debut-single-useless-bhawra-with-a-spectacular-launch-at-golden-temple/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://postmannews.com/saregamas-talent-pragati-nagpal-unveils-debut-single-useless-bhawra-with-a-spectacular-launch-at-golden-temple/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://postmannews.com/saregamas-talent-pragati-nagpal-unveils-debut-single-useless-bhawra-with-a-spectacular-launch-at-golden-temple/",
    },
    },

    {
      name: "Punekar News",
    price: "$118.75 USD",
    description: "A regional platform delivering community updates, civic issues, and cultural narratives from Pune. It connects with audiences who appreciate localized reporting with national relevance.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.punekarnews.in/from-dream-to-reality-hero-fincorps-personal-loans-make-dream-wedding-planning-a-breeze/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.punekarnews.in/from-dream-to-reality-hero-fincorps-personal-loans-make-dream-wedding-planning-a-breeze/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.punekarnews.in/from-dream-to-reality-hero-fincorps-personal-loans-make-dream-wedding-planning-a-breeze/",
    },
    },

    {
      name: "QNA India",
    price: "$118.75 USD",
    description: "A minimalist, modern news brand offering sharp insights across politics, business, and society. It serves readers who prefer clear, concise coverage of India’s evolving landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.qnaindia.com/mammootty-to-suresh-gopi-prachi-tehlan-works-with-souths-finest/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.qnaindia.com/mammootty-to-suresh-gopi-prachi-tehlan-works-with-souths-finest/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.qnaindia.com/mammootty-to-suresh-gopi-prachi-tehlan-works-with-souths-finest/",
    },
    },

    {
      name: "Republic World",
    price: "$192.5 USD",
    description: "A bold lifestyle and culture publication spotlighting trends, personalities, and contemporary narratives. It’s built for readers who enjoy stylish, engaging coverage with a modern edge.",
    stats: {
      wordsAllowed: "Upto 800",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.republicworld.com/initiatives/living-golden-on-better-terms-why-term-insurance-must-be-part-of-your-retirement-planning/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.qnaindia.com/mammootty-to-suresh-gopi-prachi-tehlan-works-with-souths-finest/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.republicworld.com/initiatives/living-golden-on-better-terms-why-term-insurance-must-be-part-of-your-retirement-planning/",
    },
    },

    {
      name: "Resident Weekly",
    price: "$31.25 USD",
    description: "A glossy magazine offering insights into luxury living, travel, and high-profile interviews. It connects with audiences who value aspirational stories and curated perspectives on lifestyle and culture.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.residentweekly.com/heavily-funded-startups-will-succumb-to-premature-scaling-in-2019/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.residentweekly.com/heavily-funded-startups-will-succumb-to-premature-scaling-in-2019/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.residentweekly.com/heavily-funded-startups-will-succumb-to-premature-scaling-in-2019/",
    },
    },

    {
      name: "RVCJ",
    price: "$118.75 USD",
    description: "A digital entertainment brand delivering viral content, humor, and pop culture commentary. It serves audiences who prefer lively, relatable storytelling across social platforms and youth-driven conversations.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.rvcj.com/ageless-vitality-and-wellness-with-civsa/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.rvcj.com/ageless-vitality-and-wellness-with-civsa/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.rvcj.com/ageless-vitality-and-wellness-with-civsa/",
    },
    },

    {
      name: "Silicon India",
    price: "$156.25 USD",
    description: "A business and technology platform spotlighting entrepreneurship, innovation, and industry leadership. It connects with professionals who value curated insights into India’s growing tech and startup ecosystem.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.siliconindia.com/news/general/beyond-the-screen-yolo247--social-side-of-online-gaming-nid-228204-cid-1.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.siliconindia.com/news/general/beyond-the-screen-yolo247--social-side-of-online-gaming-nid-228204-cid-1.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.siliconindia.com/news/general/beyond-the-screen-yolo247--social-side-of-online-gaming-nid-228204-cid-1.html",
    },
    },

    
    {
      name: "Social News + Apple News",
    price: "$118.75 USD",
    description: "A global news aggregator offering personalized, trusted coverage across diverse topics and publishers. It serves audiences who prefer streamlined, accessible updates tailored to their interests.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.socialnews.xyz/2024/04/15/urvashi-rautela-filters-lion-hearted-jr-ntr-as-they-catch-up-at-a-gym/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.socialnews.xyz/2024/04/15/urvashi-rautela-filters-lion-hearted-jr-ntr-as-they-catch-up-at-a-gym/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.socialnews.xyz/2024/04/15/urvashi-rautela-filters-lion-hearted-jr-ntr-as-they-catch-up-at-a-gym/",
    },
    },

    {
      name: "Sportz Weekly",
    price: "$28.125 USD",
    description: "A sports-focused outlet delivering match updates, athlete stories, and commentary on games worldwide. It’s built for fans who enjoy dynamic, engaging coverage of sporting events and culture.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.sportzweekly.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.sportzweekly.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/%20",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.sportzweekly.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/%20",
    },
    },

    
    {
      name: "Tech Circle",
    price: "$425 USD",
    description: "A technology and startup-focused platform offering insights into innovation, entrepreneurship, and industry trends. It connects with professionals who value curated coverage of India’s evolving business and tech ecosystem",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.techcircle.in/2023/11/01/if-you-re-a-crypto-investor-or-trader-you-shouldn-t-miss-these-3-crypto-events",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.techcircle.in/2023/11/01/if-you-re-a-crypto-investor-or-trader-you-shouldn-t-miss-these-3-crypto-events",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.techcircle.in/2023/11/01/if-you-re-a-crypto-investor-or-trader-you-shouldn-t-miss-these-3-crypto-events",
    },
    },

    {
      name: "Tech News Vision",
    price: "$28.125 USD",
    description: "A digital outlet spotlighting updates in technology, gadgets, and global innovation. It serves readers who prefer accessible, timely reporting on the latest developments in science and tech.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.technewsvision.com/marvin-steinberg-the-visionary-investor-shaping-the-future/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.technewsvision.com/marvin-steinberg-the-visionary-investor-shaping-the-future/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.technewsvision.com/marvin-steinberg-the-visionary-investor-shaping-the-future/",
    },
    },

    {
      name: "Telegraph India (No Index)",
    price: "$206.25 USD",
    description: "A respected publication delivering credible journalism across politics, culture, and business, now in digital form. It caters to audiences who value trusted reporting with the convenience of online access.",
    stats: {
      wordsAllowed: "Upto 1200",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.telegraphindia.com/press-releases/guide-to-download-twitch-vod-libraries/cid/2015891",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.telegraphindia.com/press-releases/guide-to-download-twitch-vod-libraries/cid/2015891",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.telegraphindia.com/press-releases/guide-to-download-twitch-vod-libraries/cid/2015891",
      },
      brand2:{
        name: "Telegraph India Corp (No Index)",
    price: "$400 USD",
    description: "A respected publication delivering credible journalism across politics, culture, and business, now in digital form. It caters to audiences who value trusted reporting with the convenience of online access.",
    stats: {
      wordsAllowed: "Upto 1200",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.telegraphindia.com/press-releases/guide-to-download-twitch-vod-libraries/cid/2015891",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.telegraphindia.com/press-releases/guide-to-download-twitch-vod-libraries/cid/2015891",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.telegraphindia.com/press-releases/guide-to-download-twitch-vod-libraries/cid/2015891",
      },
      }
    },

    {
      name: "Telly Chakkar",
    price: "$281.25 USD",
    description: "An entertainment-focused platform spotlighting television updates, celebrity stories, and industry trends. It connects with audiences who enjoy lively, accessible coverage of India’s TV and entertainment world.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=",
    },
    },

    {
      name: "The Day Chronicle",
    price: "$43.75 USD",
    description: "A modern digital outlet delivering news, features, and perspectives across technology, business, and culture. It’s built for readers who prefer dynamic, timely reporting in a digital-first format.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://thedaychronicle.com/featured/29237/knowledgeum-academy-celebrates-its-1st-batch-of-ibdp-learners/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://thedaychronicle.com/featured/29237/knowledgeum-academy-celebrates-its-1st-batch-of-ibdp-learners/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://thedaychronicle.com/featured/29237/knowledgeum-academy-celebrates-its-1st-batch-of-ibdp-learners/",
    },
    },

    {
      name: "The Entrepreneur Story",
    price: "$37.5 USD",
    description: "A business publication highlighting entrepreneurial journeys, startup insights, and innovation-driven narratives. It serves audiences who value authentic, inspiring stories from India’s growing entrepreneurial ecosystem.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://theentrepreneurstory.com/business/miss-meenakshi-varshney-crafting-dreams-with-vintage-decor-and-exceptional-customer-experiences-at-miskc-decor/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theentrepreneurstory.com/business/miss-meenakshi-varshney-crafting-dreams-with-vintage-decor-and-exceptional-customer-experiences-at-miskc-decor/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theentrepreneurstory.com/business/miss-meenakshi-varshney-crafting-dreams-with-vintage-decor-and-exceptional-customer-experiences-at-miskc-decor/",
    },
    },

    {
      name: "The Health Site",
    price: "$200 USD",
    description: "A health and wellness platform offering expert-backed advice, lifestyle tips, and medical insights. It connects with audiences who value practical, approachable content to support everyday well-being.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.thehealthsite.com/brand-solution/hair-transplantations-role-in-boosting-self-confidence-spotlight-on-turkey-1119438/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.thehealthsite.com/brand-solution/hair-transplantations-role-in-boosting-self-confidence-spotlight-on-turkey-1119438/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.thehealthsite.com/brand-solution/hair-transplantations-role-in-boosting-self-confidence-spotlight-on-turkey-1119438/",
    },
    },

    {
      name: "The Hindu",
    price: "$381.25 USD",
    description: "One of India’s most respected newspapers, known for its credibility, in-depth reporting, and cultural analysis. It serves readers who prefer thoughtful, balanced journalism across politics, society, and global affairs.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.thehindu.com/brandhub/law-prep-tutorials-continuous-dominance-in-clat-the-inside-story/article68016857.ece",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.thehindu.com/brandhub/law-prep-tutorials-continuous-dominance-in-clat-the-inside-story/article68016857.ece",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.thehindu.com/brandhub/law-prep-tutorials-continuous-dominance-in-clat-the-inside-story/article68016857.ece",
    },
    brand2:{
      name: "The Hindu (Facebook Sharing / 3 images in Articles & 1 Video)",
    price: "$468.75 USD",
    description: "One of India’s most respected newspapers, known for its credibility, in-depth reporting, and cultural analysis. It serves readers who prefer thoughtful, balanced journalism across politics, society, and global affairs.",
    stats: {
      wordsAllowed: "Upto 2500",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.thehindu.com/brandhub/law-prep-tutorials-continuous-dominance-in-clat-the-inside-story/article68016857.ece",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.thehindu.com/brandhub/law-prep-tutorials-continuous-dominance-in-clat-the-inside-story/article68016857.ece",
      trafficChecker: "#",
    },
    }
    },
    {
      name: "ET Now",
    price: "$437.5 USD",
    description: "A leading business news channel delivering market updates, investment insights, and economic analysis. It’s built for audiences who value timely, reliable coverage of India’s financial and corporate landscape.",
    stats: {
      wordsAllowed: "Upto 2000",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.etnownews.com/markets/rajnish-wellness-poised-for-major-leap-indian-railways-partnership-sparks-stock-market-buzz-article-112685261",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.etnownews.com/markets/rajnish-wellness-poised-for-major-leap-indian-railways-partnership-sparks-stock-market-buzz-article-112685261",
      trafficChecker: "#",
    },
    },

    {
      name: "TechStory",
    price: "$181.25 USD",
    description: "A digital platform spotlighting startups, innovation, and entrepreneurial journeys. It connects with readers who value inspiring stories and curated insights into India’s evolving tech and business ecosystem.",
    stats: {
      wordsAllowed: "Upto 2000",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://techstory.in/bookmytrain/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://techstory.in/bookmytrain/%20",
      trafficChecker: "#",
    },
    brand2:{
      name: "TechStory (Crypto)",
    price: "$206.25 USD",
    description: "A digital platform spotlighting startups, innovation, and entrepreneurial journeys. It connects with readers who value inspiring stories and curated insights into India’s evolving tech and business ecosystem.",
    stats: {
      wordsAllowed: "Upto 2000",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://techstory.in/the-most-googled-crypto-today-shows-etfswap-etfs-is-better-than-algotech-algt-and-cybro/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://techstory.in/the-most-googled-crypto-today-shows-etfswap-etfs-is-better-than-algotech-algt-and-cybro/",
      trafficChecker: "#",
    },
    }

    },

    {
      name: "Times Now",
    price: "$437.5 USD",
    description: "A leading English news channel delivering sharp reporting, debates, and national updates. It serves audiences who prefer dynamic, accessible coverage of stories shaping India and the world.",
    stats: {
      wordsAllowed: "Upto 2000",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.timesnownews.com/business-economy/markets/rajnish-wellness-poised-for-major-leap-indian-railways-partnership-sparks-stock-market-buzz-article-112684922",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.timesnownews.com/business-economy/markets/rajnish-wellness-poised-for-major-leap-indian-railways-partnership-sparks-stock-market-buzz-article-112684922",
      trafficChecker: "#",
    },
    },

    
    {
      name: "The Influencers Story",
    price: "$31.25 USD",
    description: "A communications agency specializing in digital branding, public relations, and social media strategy. It’s built for clients who seek impactful storytelling and measurable engagement in the digital space.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://theinfluencersstory.com/featured/navigating-the-crypto-cosmos-deciphering-advice-from-the-rising-stars/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theinfluencersstory.com/featured/navigating-the-crypto-cosmos-deciphering-advice-from-the-rising-stars/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theinfluencersstory.com/featured/navigating-the-crypto-cosmos-deciphering-advice-from-the-rising-stars/",
    },
    },

    {
      name: "The Live Ahmedabad",
    price: "$37.5 USD",
    description: "A city-focused platform delivering timely updates, cultural stories, and civic reporting from Ahmedabad. It connects with readers who value localized coverage with a strong sense of community identity.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://theliveahmedabad.com/2024/04/15/89-bottles-of-amrut-whiskey-seized/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theliveahmedabad.com/2024/04/15/89-bottles-of-amrut-whiskey-seized/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theliveahmedabad.com/2024/04/15/89-bottles-of-amrut-whiskey-seized/",
    },
    },

    {
      name: "The Live Nagpur",
    price: "$51.25 USD",
    description: "A regional outlet spotlighting news, features, and perspectives from Nagpur. It serves audiences who prefer accessible, modern reporting tailored to their city’s evolving social and civic landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://thelivenagpur.com/2024/04/15/balodyan-garden-transformation-new-attractions-await-visitors/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://thelivenagpur.com/2024/04/15/balodyan-garden-transformation-new-attractions-await-visitors/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://thelivenagpur.com/2024/04/15/balodyan-garden-transformation-new-attractions-await-visitors/",
    },
    },
    
    {
      name: "The Logical India",
    price: "$237.5 USD",
    description: "A digital media brand championing fact-based journalism, social impact stories, and civic awareness. It’s built for readers who value credible, thoughtful narratives that inspire dialogue and change.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://thelogicalindian.com/finance/fixed-deposit-41753",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://thelogicalindian.com/finance/fixed-deposit-41753",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://thelogicalindian.com/finance/fixed-deposit-41753",
    },
    },


    {
      name: "The Prevalent India",
    price: "$43.75 USD",
    description: "A digital outlet spotlighting national updates, cultural narratives, and civic issues. It connects with readers who prefer accessible, timely coverage of India’s evolving social and political landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.theprevalentindia.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.theprevalentindia.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.theprevalentindia.com/mahadev-betting-case-ed-strikes-hard-real-owner-of-the-mahadev-girish-talreja-arrested-co-owner-ratan-lal-jain-is-absconding/",
    },
    },

    
    {
      name: "The Prime Time",
    price: "$56.25 USD",
    description: "A broadcast platform delivering sharp debates, current affairs, and investigative features. It’s built for audiences who value dynamic, engaging coverage of stories shaping public discourse.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://theprimetime.in/transitioning-mid-career-from-data-analytics-to-artificial-intelligence-using-transferable-skills/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theprimetime.in/transitioning-mid-career-from-data-analytics-to-artificial-intelligence-using-transferable-skills/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theprimetime.in/transitioning-mid-career-from-data-analytics-to-artificial-intelligence-using-transferable-skills/",
    },
    },

    
    {
      name: "The Print",
    price: "$187.5 USD",
    description: "A respected digital publication offering in-depth analysis, commentary, and credible reporting. It serves readers who appreciate thoughtful journalism across politics, policy, and society.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://theprint.in/brandstand/adon/the-growing-popularity-of-rupay-credit-cards-reasons-to-apply-today/2134563/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theprint.in/brandstand/adon/the-growing-popularity-of-rupay-credit-cards-reasons-to-apply-today/2134563/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theprint.in/brandstand/adon/the-growing-popularity-of-rupay-credit-cards-reasons-to-apply-today/2134563/",
    },
    },

     
    {
      name: "The Quint",
    price: "$243.75 USD",
    description: "A digital-first media brand delivering sharp commentary, investigative stories, and youth-driven narratives. It connects with audiences who value bold, engaging journalism across politics, culture, and social issues.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.thequint.com/brandstudio/quick-business-loans-machinery-financing-india",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.thequint.com/brandstudio/quick-business-loans-machinery-financing-india",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.thequint.com/brandstudio/quick-business-loans-machinery-financing-india",
    },
    brand2:{
      name: "The Quint Corporate",
    price: "$562.5 USD",
    description: "A digital-first media brand delivering sharp commentary, investigative stories, and youth-driven narratives. It connects with audiences who value bold, engaging journalism across politics, culture, and social issues.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.thequint.com/brandstudio/bajaj-finserv-credit-pass-manage-credit-health-secure-loans",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.thequint.com/brandstudio/bajaj-finserv-credit-pass-manage-credit-health-secure-loans",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.thequint.com/brandstudio/bajaj-finserv-credit-pass-manage-credit-health-secure-loans",
    },
    }
    },

    
    {
      name: "The UBJ",
    price: "$100 USD",
    description: "A modern outlet spotlighting business, lifestyle, and cultural perspectives with a contemporary voice. It serves readers who prefer dynamic, accessible coverage tailored to global and local contexts",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://theubj.com/featured/former-hostage-takes-on-life-with-a-new-perspective/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://theubj.com/featured/former-hostage-takes-on-life-with-a-new-perspective/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://theubj.com/featured/former-hostage-takes-on-life-with-a-new-perspective/",
    },
    },

    {
      name: "The Week",
    price: "Closed for few months",
    description: "A digital extension of the magazine offering real-time updates, features, and commentary. It’s built for audiences who appreciate credible journalism with the immediacy of live reporting.",
    stats: {
      wordsAllowed: "",
      backlinksAllowed: "",
      sponsoredDisclaimer: "",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Time Bulletin",
    price: "$28.125 USD",
    description: "A digital outlet delivering concise updates and curated features across politics, business, and society. It’s built for readers who prefer accessible, timely coverage of current affairs.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.timebulletin.com/enabling-end-to-end-security-in-satellite-communication-systems-using-cyber-physical-systems-and-blockchain-technology/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.timebulletin.com/enabling-end-to-end-security-in-satellite-communication-systems-using-cyber-physical-systems-and-blockchain-technology/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.timebulletin.com/enabling-end-to-end-security-in-satellite-communication-systems-using-cyber-physical-systems-and-blockchain-technology/",
    },
    },

    {
      name: "Times of India",
    price: "$1525 USD",
    description: "One of India’s most prominent newspapers, known for its wide reach, credible reporting, and cultural influence. It connects with audiences who value comprehensive coverage of national and global events.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://timesofindia.indiatimes.com/life-style/fashion/luxury/featured/dubais-iconic-meena-jewellers-celebrates-30-years-of-legacy/articleshow/108226388.cms",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://timesofindia.indiatimes.com/life-style/fashion/luxury/featured/dubais-iconic-meena-jewellers-celebrates-30-years-of-legacy/articleshow/108226388.cms",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://timesofindia.indiatimes.com/life-style/fashion/luxury/featured/dubais-iconic-meena-jewellers-celebrates-30-years-of-legacy/articleshow/108226388.cms",
    },
    brand2:{
      name: "Times Of India (Spotlight)",
    price: "$937.5 USD",
    description: "One of India’s most prominent newspapers, known for its wide reach, credible reporting, and cultural influence. It connects with audiences who value comprehensive coverage of national and global events.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://timesofindia.indiatimes.com/business/india-business/top-10-old-b-schools-in-india/articleshow/108268369.cms",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://timesofindia.indiatimes.com/business/india-business/top-10-old-b-schools-in-india/articleshow/108268369.cms",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://timesofindia.indiatimes.com/business/india-business/top-10-old-b-schools-in-india/articleshow/108268369.cms",
    },
    }
    },

    {
      name: "Trade Brains",
    price: "$112.5 USD",
    description: "A financial education platform offering investment insights, market analysis, and practical learning tools. It serves readers who want clear, approachable guidance to build confidence in investing.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://tradebrains.in/features/how-to-get-more-followers-on-instagram/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://tradebrains.in/features/how-to-get-more-followers-on-instagram/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://tradebrains.in/features/how-to-get-more-followers-on-instagram/",
    },
    },

    
        {
      name: "Tribune India",
    price: "$122.5 USD",
    description: "A historic newspaper known for its credibility, civic reporting, and cultural narratives. It connects with readers who value thoughtful journalism and a strong voice on public issues.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.tribuneindia.com/news/impact-feature/jio-5g-rollout-and-its-impact-on-mobile-data-speeds-609761",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.tribuneindia.com/news/impact-feature/jio-5g-rollout-and-its-impact-on-mobile-data-speeds-609761",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.tribuneindia.com/news/impact-feature/jio-5g-rollout-and-its-impact-on-mobile-data-speeds-609761",
    },
    },

      {
      name: "True Scoop News (1 DoFollow)",
    price: "$122.5 USD",
    description: "A modern digital outlet delivering bold, accessible coverage of current affairs and social stories. It serves audiences who prefer sharp, engaging reporting with a contemporary edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
    },
    brand2:{
      name: "True Scoop News (2 DoFollow)",
    price: "$168.75 USD",
    description: "A modern digital outlet delivering bold, accessible coverage of current affairs and social stories. It serves audiences who prefer sharp, engaging reporting with a contemporary edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
    },
    },
    brand3:{
 name: "True Scoop News (2 NF)",
    price: "$106.25 USD",
    description: "A modern digital outlet delivering bold, accessible coverage of current affairs and social stories. It serves audiences who prefer sharp, engaging reporting with a contemporary edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
    },
    
    },
    brand4:{
      name: "True Scoop News (3 NF)",
    price: "$110 USD",
    description: "A modern digital outlet delivering bold, accessible coverage of current affairs and social stories. It serves audiences who prefer sharp, engaging reporting with a contemporary edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.truescoopnews.com/newsdetail/fast-refund-group-review-how-professional-funds-recovery-service",
    },

    }
    },

      {
      name: "Tech Bullion",
    price: "$68.75 USD",
    description: "A global platform spotlighting technology, finance, and innovation. It’s built for professionals and readers who value in-depth insights into fintech, startups, and emerging business trends.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://techbullion.com/the-fusion-of-crypto-and-ai-exploring-pantherai/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://techbullion.com/the-fusion-of-crypto-and-ai-exploring-pantherai/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://techbullion.com/the-fusion-of-crypto-and-ai-exploring-pantherai/",
    },
    },
    {
      name: "Us Times Now",
    price: "$28.125 USD",
    description: "A leading English news channel delivering sharp debates, breaking updates, and national coverage. It connects with audiences who value dynamic, accessible reporting on stories shaping India and beyond.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ustimesnow.com/briana-stout-creates-phenomenal-success-with-her-eco-friendly-self-care-brand-illuminate-b-candles/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.ustimesnow.com/briana-stout-creates-phenomenal-success-with-her-eco-friendly-self-care-brand-illuminate-b-candles/",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.ustimesnow.com/briana-stout-creates-phenomenal-success-with-her-eco-friendly-self-care-brand-illuminate-b-candles/",
    },
    },

    {
      name: "VCC Circle",
    price: "$418.75 USD",
    description: "A business and investment-focused platform spotlighting startups, venture capital, and private equity insights. It serves professionals who prefer curated analysis of India’s entrepreneurial and financial ecosystem.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.vccircle.com/gruhasgusto-kicks-off-its-maiden-cohort-accelerator-program-with-the-selection-of-7-exciting-start-ups",
      daChecker: "#",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.vccircle.com/gruhasgusto-kicks-off-its-maiden-cohort-accelerator-program-with-the-selection-of-7-exciting-start-ups",
    },
    },
    
    {
      name: "Verna Magazine",
    price: "$28.125 USD",
    description: "A modern media brand offering perspectives across business, culture, and innovation. It’s built for readers who appreciate concise, contemporary coverage with a bold visual identity.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.vernamagazine.com/briana-stout-turns-passion-into-lifestyle-with-illuminate-b-candles/",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.vccircle.com/gruhasgusto-kicks-off-its-maiden-cohort-accelerator-program-with-the-selection-of-7-exciting-start-ups",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.vernamagazine.com/briana-stout-turns-passion-into-lifestyle-with-illuminate-b-candles/",
    },
    },
    
    {
      name: "Vibes Of India",
    price: "$93.75 USD",
    description: "A digital platform spotlighting cultural narratives, civic issues, and contemporary stories from Gujarat and beyond. It connects with readers who value localized coverage with a modern, community-driven voice.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.vibesofindia.com/amit-singh-and-hi-mission-to-empower-individuals-against-cyber-threats/#:~:text=Amit%20Singh%20highlights%20that%20his,positive%20change%20to%20the%20industry.",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.vibesofindia.com/amit-singh-and-hi-mission-to-empower-individuals-against-cyber-threats/#:~:text=Amit%20Singh%20highlights%20that%20his,positive%20change%20to%20the%20industry.",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.vibesofindia.com/amit-singh-and-hi-mission-to-empower-individuals-against-cyber-threats/#:~:text=Amit%20Singh%20highlights%20that%20his,positive%20change%20to%20the%20industry.",
    },
    },

    {
      name: "Yahoo Finance (Approval Basis)",
    price: "$300 USD",
    description: "A global financial news and data service offering market insights, investment tools, and economic analysis. It serves audiences who prefer accessible, real-time updates tailored to both professionals and everyday investors.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://finance.yahoo.com/news/ox-fun-launches-copy-trading-145000031.html",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://finance.yahoo.com/news/ox-fun-launches-copy-trading-145000031.html",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://finance.yahoo.com/news/ox-fun-launches-copy-trading-145000031.html",
    },
    },

    
    {
      name: "YourStory",
    price: "$937.5 USD",
    description: "A storytelling-driven media brand highlighting startups, entrepreneurs, and innovation across India. It’s built for readers who value authentic, inspiring narratives about business journeys and creative leadership.",
    stats: {
      wordsAllowed: "Upto 1500",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://yourstory.com/2024/04/evolutyzs-unmaze-2023-sets-new-corporate-recognition-standard",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://yourstory.com/2024/04/evolutyzs-unmaze-2023-sets-new-corporate-recognition-standard",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://yourstory.com/2024/04/evolutyzs-unmaze-2023-sets-new-corporate-recognition-standard",
    },
    },

    
    {
      name: "Zee Biz",
    price: "$200 USD",
    description: "A leading business news channel delivering market updates, investment insights, and economic analysis. It connects with audiences who value timely, reliable coverage of India’s financial and corporate landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.zeebiz.com/agencies/pressure-sensitive-systems-india-limited-poised-for-growth-with-strong-financials-and-expansion-plans-279099#:~:text=The%20company%20has%20recently%20reported,has%20demonstrated%20robust%20financial%20health.",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Zee News",
    price: "$206.25 USD",
    description: "A prominent Hindi news channel offering national updates, debates, and cultural stories. It serves audiences who prefer accessible, dynamic coverage of current affairs across India.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://zeenews.india.com/india/protecting-the-truth-in-india-an-existential-threat-to-a-new-global-power-2727265.html#:~:text=What%20today's%20challenge%20demands%20is,to%20the%20world's%20newest%20superpower.",
      daChecker: "#",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://zeenews.india.com/india/protecting-the-truth-in-india-an-existential-threat-to-a-new-global-power-2727265.html#:~:text=What%20today's%20challenge%20demands%20is,to%20the%20world's%20newest%20superpower.",
    },
    },

    
    {
      name: "Entrepreneur India (Approval Basis)",
    price: "$1500 USD",
    description: "A business publication spotlighting startups, leadership, and innovation. It’s built for readers who value authentic, inspiring narratives about entrepreneurship and the evolving business ecosystem.",
    stats: {
      wordsAllowed: "Upto 700",
      backlinksAllowed: "1",
      sponsoredDisclaimer: "Yes",
    },
    links: {
      samples: "https://www.entrepreneur.com/en-in/technology/how-an-eminent-technology-leader-is-helping-digital/472101",
      daChecker: "https://ahrefs.com/website-authority-checker/?input=https://www.entrepreneur.com/en-in/technology/how-an-eminent-technology-leader-is-helping-digital/472101",
      trafficChecker: "https://ahrefs.com/traffic-checker/?input=https://www.entrepreneur.com/en-in/technology/how-an-eminent-technology-leader-is-helping-digital/472101",
    },
    },

    {
      name: "Cricket Country",
    price: "$162.5 USD",
    description: "A sports platform dedicated to cricket news, match updates, and player insights. It connects with fans who value comprehensive, engaging coverage of the game across formats and geographies.",
    stats: {
      wordsAllowed: "Upto 800",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.cricketcountry.com/brand-solution/the-unsurprising-popularity-of-cricket-in-the-philippines-1068668/",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "CIO Tech Outlook DoFollow",
    price: "$122.5 USD",
    description: "A technology publication spotlighting enterprise innovation, IT leadership, and digital transformation. It serves professionals who prefer in-depth analysis and curated insights into the evolving tech landscape.",
    stats: {
      wordsAllowed: "Upto 800",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://www.ciotechoutlook.com/industry/finance/news/term-life-insurance-under-section-80d--its-role-in-tax-planning-nid-12781-cid-63.html",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "Her Zindagi",
    price: "$193.75 USD",
    description: "A lifestyle and wellness portal offering stories on health, relationships, and personal growth. It’s built for readers who enjoy approachable, relatable content designed to inspire everyday living.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "News Gram DoFollow",
    price: "$137.5 USD",
    description: "A local news platform spotlighting civic updates, cultural stories, and community voices from Nashik. It connects with readers who value timely, accessible coverage rooted in their city’s identity.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Startupnews.fyi DoFollow",
    price: "$116.25 USD",
    description: "A digital outlet dedicated to startup updates, entrepreneurial journeys, and innovation-driven stories. It serves audiences who prefer concise, modern reporting tailored to India’s growing startup ecosystem.",
    stats: {
      wordsAllowed: "Upto 800",
      backlinksAllowed: "2",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "https://startupnews.fyi/2024/11/14/8-essential-business-management-skills-for-a-successful-leadership-career/",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "The Jet News",
    price: "$28.125 USD",
    description: "A fast-paced news channel delivering real-time updates, breaking stories, and dynamic coverage. It’s built for viewers who value immediacy and engaging reporting across politics, business, and society.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "The NewYork Express",
    price: "$28.125 USD",
    description: "A regional outlet spotlighting civic updates, cultural stories, and lifestyle features from New York. It connects with readers who value accessible, city-focused coverage with a modern, energetic voice.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "London Journal News",
    price: "$28.125 USD",
    description: "A bold digital platform delivering timely updates, features, and commentary from London. It serves audiences who prefer sharp, contemporary reporting tailored to the city’s evolving social and civic landscape.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The News Shift",
    price: "$28.125 USD",
    description: "A modern publication offering fresh perspectives on culture, society, and innovation. It’s built for readers who appreciate minimalist design paired with thoughtful, forward-looking journalism.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "The News Jack",
    price: "$28.125 USD",
    description: "A creative media brand blending journalism with audio-driven storytelling. It connects with audiences who enjoy sharp, innovative coverage delivered through modern, multimedia formats.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Washington Times Now",
    price: "$28.125 USD",
    description: "A traditional American newspaper known for its conservative perspectives, political reporting, and cultural commentary. It serves readers who value formal, opinion-driven journalism alongside national and global news.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

        {
      name: "Yoast News",
    price: "$28.125 USD",
    description: "A leading SEO solutions company offering tools and plugins to optimize websites for search engines. It’s built for digital creators and businesses who want accessible, effective strategies to grow online visibility.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
      

    {
      name: "Weelz News",
    price: "$28.125 USD",
    description: "A satirical media brand parodying mainstream news formats with exaggerated, tongue-in-cheek reporting. It connects with audiences who enjoy humor, irony, and playful takes on current events.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "United International News",
    price: "$28.125 USD",
    description: "A global news agency delivering concise, factual updates across politics, business, and culture. It serves readers who value accessible, international coverage with a straightforward voice.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "The Printed News",
    price: "$28.125 USD",
    description: "A respected digital publication offering in-depth analysis, commentary, and credible reporting. It’s built for readers who appreciate thoughtful journalism across politics, policy, and society.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Atlanta News World",
    price: "$28.125 USD",
    description: "A regional news outlet delivering timely updates, civic reporting, and cultural stories from Atlanta. It connects with audiences who value accessible, community-focused journalism with a strong local voice.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Bebbo News",
    price: "$28.125 USD",
    description: "A family-oriented digital platform offering playful, supportive content for parents and children. It serves audiences who enjoy approachable, friendly resources designed to inspire learning and connection.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Business Net News",
    price: "$28.125 USD",
    description: "A business-focused channel delivering market updates, corporate insights, and financial analysis. It’s built for professionals and viewers who value clear, timely coverage of the global economy.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Club Olive News",
    price: "$28.125 USD",
    description: "A lifestyle-driven brand fostering global community, culture, and connection. It’s built for audiences who value vibrant experiences and narratives that celebrate living fully.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "Eiviera News",
    price: "$28.125 USD",
    description: "A sleek, modern platform spotlighting business, culture, and innovation. It connects with readers who prefer contemporary perspectives and streamlined storytelling with an international edge.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    
    
    {
      name: "Entrepreneur Net News",
    price: "$28.125 USD",
    description: "A business-focused outlet delivering updates on startups, leadership, and market trends. It serves professionals and readers who value timely, credible coverage of entrepreneurship and enterprise growth.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Express Ezee",
    price: "$28.125 USD",
    description: "A technology-driven brand offering smart solutions across hospitality and business services. It connects with clients who value streamlined, innovative tools designed to simplify operations and enhance customer experiences.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Free Hitz News",
    price: "$28.125 USD",
    description: "An energetic entertainment platform delivering music, pop culture, and lifestyle content. It serves audiences who enjoy vibrant, playful coverage that reflects contemporary trends and youthful energy.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Maczee News",
    price: "$28.125 USD",
    description: "A modern brand spotlighting growth, innovation, and digital solutions. It’s built for professionals and businesses who value approachable, forward-looking tools to drive success and visibility.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Malaysia Daily Post",
    price: "$28.125 USD",
    description: "A digital platform delivering timely updates, civic reporting, and cultural stories from Malaysia. It connects with readers who value accessible coverage paired with a strong national identity.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Match 24x7 News",
    price: "$28.125 USD",
    description: "A fast-paced outlet providing round-the-clock updates across politics, business, and society. It serves audiences who prefer immediacy and dynamic reporting on global and local events.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "MHTC News",
    price: "$28.125 USD",
    description: "A government-backed initiative promoting Malaysia as a destination for medical tourism. It’s built for international patients and partners who value trusted healthcare services combined with travel opportunities.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Get Universal News",
    price: "$28.125 USD",
    description: "A global outlet delivering updates across politics, business, and culture. It connects with audiences who value accessible, straightforward coverage of international events and civic issues.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

       {
      name: "Kevin Hearld",
    price: "$28.125 USD",
    description: "A luxury fragrance brand blending elegance with individuality. It serves customers who appreciate perfumes designed to resonate deeply with personal identity and soul.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

     {
      name: "Middle East Hunt",
    price: "$28.125 USD",
    description: "An energy company focused on oil exploration and production in the Middle East. It’s built for partners and stakeholders who value trusted expertise and global reach in the energy sector.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
     {
      name: "News 1 Minute",
    price: "$28.125 USD",
    description: "A broadcast outlet delivering concise, accessible updates across politics, culture, and society. It connects with audiences who value straightforward, real-time coverage of current events.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Rich News Plus",
    price: "$28.125 USD",
    description: "A global food company specializing in bakery, culinary, and retail solutions. It serves businesses and consumers who appreciate innovative, high-quality products designed to inspire creativity in foodservice.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Seattle Daily Post",
    price: "$28.125 USD",
    description: "A historic newspaper known for its investigative reporting, civic coverage, and cultural commentary. It’s built for readers who value thoughtful journalism with a strong regional voice.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "Stock News Hunt",
    price: "$28.125 USD",
    description: "A digital news platform spotlighting timely updates, civic issues, and cultural stories. It connects with readers who value sharp, accessible reporting designed to uncover and highlight the stories that matter most.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "News QWERTY",
    price: "$28.125 USD",
    description: "A technology brand offering innovative digital services in search, analysis, and online growth. It’s built for businesses and creators who value smart, tailored solutions to strengthen their digital presence.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "News Revital",
    price: "$28.125 USD",
    description: "ReVital Polymers is a leader in plastic recycling and recovery, specializing in turning post-consumer waste into high-quality resin. They are dedicated to advancing the circular economy by providing sustainable material solutions for North American manufacturers.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    
    {
      name: "My Exclusive News",
    price: "$28.125 USD",
    description: "MyNews is a versatile digital platform designed to keep communities and organizations informed with real-time updates and localized stories. It streamlines communication by delivering personalized news and essential alerts directly to users' devices.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

     
    {
      name: "News Aviator",
    price: "$28.125 USD",
    description: "Aviator News is the student-led publication of Hawthorne Math & Science Academy, providing a voice for the campus community. It covers school events, academic achievements, and local stories, fostering student engagement through journalism.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

     
    {
      name: "News Leves",
    price: "$28.125 USD",
    description: "News in Levels is an educational project designed to help English learners improve their language skills through current events. They provide news stories written at three different levels of difficulty, allowing students to read and listen to content that matches their specific vocabulary and grammar proficiency.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

        {
      name: "Tes Magazine",
    price: "$28.125 USD",
    description: "Established in 1910, Tes Magazine (formerly the Times Educational Supplement) is a leading UK-based publication for the education sector. It provides teachers and school leaders with the latest industry news, pedagogical research, and professional development resources to support excellence in the classroom.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "The 1 Day News",
    price: "$28.125 USD",
    description: "Day1 is a non-profit media ministry that serves as the successor to The Protestant Hour, broadcasting for over 75 years. It features prominent preachers from various mainline denominations, offering ecumenical radio programs and digital content focused on faith, inspiration, and community building.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "Perfect World News",
    price: "$28.125 USD",
    description: "Perfect World Entertainment, now rebranded as Arc Games, is a leading publisher of acclaimed online multiplayer titles like Neverwinter and Star Trek Online. The company focuses on bringing high-quality, free-to-play fantasy and sci-fi experiences to a global audience across PC and console platforms.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    
    {
      name: "Next Hour News",
    price: "$28.125 USD",
    description: "Next Hour, operating under the HRH Next brand, is a premier Business Process Management (BPM) company with over 80 years of heritage in South India. They specialize in delivering AI-enabled customer experience solutions, including multilingual call center support, digital chat, and backend services for top-tier global brands.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Agriculture News",
    price: "$28.125 USD",
    description: "Agri News Network (ANN) is a specialized media platform dedicated to putting agriculture at the forefront of the national conversation. Through expert interviews and field reports, the network highlights critical farming challenges while providing actionable solutions for stakeholders and the rural community.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Indiana News",
    price: "$28.125 USD",
    description: "Indiana News is a dedicated regional media outlet providing comprehensive coverage of local politics, community events, and sports across the state. They focus on delivering timely updates and in-depth reporting that matters most to Hoosier residents.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

    {
      name: "The Insta Bulletin",
    price: "$28.125 USD",
    description: "The India Bulletin serves as a vital information hub for the Indian diaspora, covering international news, cultural developments, and business trends. It acts as a bridge between global audiences and the latest happenings from the Indian subcontinent.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "News One Direction",
    price: "$28.125 USD",
    description: "One Direction is a globally recognized pop culture brand originating from the world-famous boy band formed in 2010. While the group is currently on hiatus, the brand continues to manage an extensive catalog of music, merchandise, and media that remains influential in the entertainment industry.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Deluxe News",
    price: "$28.125 USD",
    description: "Deluxe India is a subsidiary of the world’s leading content services company, providing comprehensive end-to-end solutions from localization to distribution. Their expert teams support global media and entertainment creators with specialized services in mastering, subtitling, dubbing, and high-quality audio mixing for cinema and streaming platforms.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Web Series News",
    price: "$28.125 USD",
    description: "Web Series TV is a digital media platform dedicated to the latest updates, reviews, and news within the rapidly growing world of streaming content and online series. The channel serves as a guide for viewers, highlighting trending shows across major OTT platforms and providing insights into upcoming digital entertainment releases.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Master Gun",
    price: "$28.125 USD",
    description: "Gun Master is a brand under Majithia Masala that offers a diverse range of products, often associated with culinary spice blends and traditional Indian seasonings. Based in Gujarat, the brand focuses on delivering authentic flavors through carefully sourced ingredients to meet the needs of household kitchens and professional chefs.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Disrupt News",
    price: "$28.125 USD",
    description: "BW Disrupt is a leading digital platform dedicated to the Indian startup ecosystem, offering deep insights into entrepreneurship, innovation, and venture capital. Part of the BW Businessworld group, it provides a stage for founders and disruptors to share their stories and stay updated on emerging business trends.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The London Reporter",
    price: "$28.125 USD",
    description: "The London Reporter is a contemporary news outlet focused on delivering timely updates, lifestyle features, and cultural news from across the UK's capital. It serves as a go-to resource for residents and visitors alike, covering everything from local government developments to the city's vibrant arts and entertainment scene.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Pen America",
    price: "$28.125 USD",
    description: "PEN America is a non-profit organization that stands at the intersection of literature and human rights, working to protect free expression worldwide. By supporting writers, editors, and journalists, they actively combat censorship and defend the liberties that make creative expression possible.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Release Wire",
    price: "$28.125 USD",
    description: "ReleaseWire is a comprehensive news release distribution and media engagement platform designed to help businesses of all sizes increase their online visibility. It provides tools for press release distribution, media monitoring, and social media integration to connect brands with journalists and global audiences effectively.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Newspreneur",
    price: "$28.125 USD",
    description: "The Newspreneur is a digital knowledge platform dedicated to providing daily insights into the world of technology, entrepreneurship, and innovation. It specializes in making complex topics like Artificial Intelligence, machine learning, and data science accessible through educational guides, passive income strategies, and the latest industry news.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The New Express",
    price: "$28.125 USD",
    description: "The New Indian Express is a prominent English-language daily newspaper in India, known for its fearless journalism and extensive coverage of national and international news. With a strong presence in Southern and Eastern India, it provides readers with in-depth analysis, political commentary, and lifestyle content.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The News Mine",
    price: "$28.125 USD",
    description: "MiningNews.net is a premier global news service providing high-level industry intelligence and real-time updates on the mining and resources sector. It offers in-depth analysis of commodity markets, stock performance, and technological advancements to help professionals and investors make informed decisions.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "First Show You",
    price: "$28.125 USD",
    description: "First Show is a pioneering Indian film marketing agency that specializes in crafting innovative 360-degree promotional strategies for the media and entertainment industry. With experience in over 200 projects, they manage everything from digital advertising and influencer marketing to video production, ensuring every film or show reaches its ideal audience",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Entrepreneurship Goals",
    price: "$28.125 USD",
    description: "Entrepreneur is a globally recognized media brand that serves as a definitive resource for business owners and innovators seeking to start and grow successful ventures. Through its magazine and digital platforms, it delivers expert advice on leadership, marketing, and small business management to an audience of millions worldwide.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Joy Express",
    price: "$28.125 USD",
    description: "Joy Express is an international logistics and delivery company that provides fast and secure on-demand express delivery within 24–72 hours. Headquartered in Dhaka, Bangladesh, it offers a wide range of services including air freight, domestic and international courier solutions, and specialized cargo handling for both personal and corporate clients.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "The Musician News",
    price: "$28.125 USD",
    description: "The Musician News is a dedicated digital media platform providing comprehensive coverage of the global music industry, from breaking news and artist interviews to album reviews and concert updates. It serves as an essential hub for both fans and industry professionals, highlighting trending stories, emerging talent, and the latest shifts in the music world.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "News Louis",
    price: "$28.125 USD",
    description: "LWTN 369 appears to be a specialized digital media or informational platform that shares updates on niche business sectors and organizational trends. While information is more limited, it is often associated with providing localized news and community-focused insights to keep stakeholders informed about shifting industry standards and public interest stories.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Sky Bulletin",
    price: "$28.125 USD",
    description: "Sky News is a major British television news channel and organization that provides 24-hour reporting on both national and international stories. Owned by Sky Group (a division of Comcast), it operates a global multi-platform news network that includes television, live streaming, radio, and digital channels.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "Celetokers",
    price: "$28.125 USD",
    description: "CelebTokers is a digital platform and media brand that focuses on the intersection of celebrity culture and social media trends, particularly within the TikTok ecosystem. It provides fans with the latest news, viral moments, and behind-the-scenes content regarding their favorite online influencers and traditional celebrities.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },
    {
      name: "News Live Time",
    price: "$28.125 USD",
    description: "Times Now is a leading 24-hour English-language news channel in India, owned and operated by the country's largest media conglomerate, The Times Group. Launched in 2006, the channel is known for its insightful analysis and flagship programs like The NewsHour, reaching viewers across more than 100 countries.",
    stats: {
      wordsAllowed: "Upto 1000",
      backlinksAllowed: "2-3",
      sponsoredDisclaimer: "No",
    },
    links: {
      samples: "#",
      daChecker: "#",
      trafficChecker: "#",
    },
    },

  ];